export default {
  login: {
    title: 'Bienvenido',
    titleDescription: 'Conéctese para acceder a su espacio cliente Ubiflow',
    username: 'Usuario',
    usernameSFC: 'Correo',
    usernamePlaceholder: 'Entre su usuario (Código cliente o correo)',
    usernamePlaceholderSFC: 'Ingrese el correo electrónico de inicio de sesión Se Faier Connaître',
    password: 'Contraseña',
    passwordPlaceholder: 'Entre su contraseña',
    logIn: 'Entrar',
    passwordLost: '¿ Contraseña perdida ?',
    passwordLostLink: 'Haga clic aquí para restablecerla',
    metaTitle: 'Conexión al espacio client Ubiflow',
    dialogSuspendedTitle: 'Área de clientes suspendida',
    dialogSuspendedText: 'Un pago atrasado impide el acceso a tu Área de Clientes de Ubiflow.<br />Puedes contactar con nuestro equipo ADV (<a href="mailto:adv@ubiflow.net">adv@ubiflow.net</a> ) para regularizar tu situación .<br /><br />Hasta pronto.',
    SFCErrorTitle: 'Error de conexion',
    SFCErrorText: 'Se encontró un error al conectarse a su área de clientes de Ubiflow - Se Faire Connaîtrer. Le pedimos disculpas por las molestias causadas. Le invitamos a ponerse en contacto con nuestro departamento de Relaciones con el Cliente por teléfono al 02.30.95.20 .00 o por correo electrónico a:'
  },
  lostPassword: {
    title: 'Contraseña perdida',
    titleDescription: 'Restablecer su contraseña',
    username: 'Nombre de usuario o correo',
    usernamePlaceholder: 'Entrar su codigo cliente o su email',
    confirm: 'OK',
    confirmationTitle: 'Contraseña perdida',
    confirmationText: 'Se le ha enviado un correo electrónico. Siga las instrucciones para restablecer sur contraseña y poder acceder a su espacio cliente.',
    backToLogin: '¿ Regresar al formulario de conexión ?',
    backToLoginLink: 'Haga clic aquí',
    metaTitle: 'Contraseña perdida',
    confirmationTitleSFC: 'Cambiar la contraseña',
    confirmationText1SFC: 'Se acaba de enviar un correo electrónico a su dirección.',
    confirmationText2SFC: 'Siga las instrucciones para renovar su contraseña y acceder a su área de cliente de Ubiflow - Se Faire Connaître.'
  },
  changePassword: {
    title: 'Contraseña perdida',
    titleDescription: 'Restablecer su contraseña',
    password1: 'Elija una contraseña',
    password1Placeholder: 'Elija una contraseña',
    password2: 'Confirme su contraseña',
    password2Placeholder: 'Confirme su contraseña',
    confirm: 'OK',
    backToLogin: '¿ Regresar al formulario de conexión ?',
    backToLoginLink: 'Haga clic aquí',
    metaTitle: 'Contraseña perdida'
  },
  activateProduct: {
    pageTitle: 'Activación del producto',
    title: 'Bienvenido',
    titleDescription: 'Ahora puede ingresar su código para activar su formulario de calificación.',
    titleDescriptionResponse: 'Has activado tu formulario. Ahora puedes cerrar esta página.',
    productActivateResponse: 'Has activado tu formulario.',
    labelCode: 'Código de activación',
    labelButton: 'Permitir',
    codeRequired: 'El código es requerido'
  },
  forbidden403: {
    title: 'Acceso prohibido',
    text: 'No tiene acceso a esta página.',
    link: 'Regresar al inicio',
    metaTitle: 'Error 403 - Acceso prohibido'
  },
  notFound404: {
    title: 'Página no encontrada',
    text: 'La página que busca no existe o ha sido desplazada.',
    link: 'Regresar al inicio',
    metaTitle: 'Error 404 - Page non trouvée'
  },
  unauthorized401: {
    title: 'Acceso no autorizado',
    text: 'Debe estar autentificado para poder acceder a esta página.',
    link: 'Conexión',
    metaTitle: 'Error 401 - Acceso no autorizado'
  },
  serverError500: {
    message: 'Se produjo un error al cargar los datos.'
  },
  layouts: {
    notificationAlerts: 'Alertas',
    notifications: 'Notificaciones',
    noNotification: 'Sin notificacion por el momento',
    createAd: 'Crear un anuncio',
    create_program: 'Crear un programa',
    contactUs: 'Contáctenos',
    portailClient: 'Mis area de facturas',
    logOut: 'Desconexión',
    goBackOldCustomerSpace: 'Regresar al antiguo espacio cliente',
    contactBook: 'Mis usuarios',
    dashboard: 'Panel principal',
    ads: 'Anuncios',
    selectionVo: 'Selección de vehículos',
    programs: 'Programas',
    home: 'Inicio',
    portals: 'Portales',
    profile: 'Perfil',
    diffusion: 'Difusión',
    contactManager: 'Contact Manager',
    localPresence: 'Presencia local',
    socialManagment: 'Social Manager',
    localReference: 'referencia local',
    postManagement: 'Gestión de correos',
    planningCalendar: 'Calendario de planificación',
    sfc: 'Se faire connaitre',
    offeredBy: 'Espacio Cliente ofrecido por',
    ubiflow: 'Ubiflow',
    legalNotice: 'Notas legales',
    conditionsOfSale: 'CGV',
    conditionsOfSaleOfDiffusion: 'CGV Difusión',
    conditionsOfSaleOfContactManager: 'CGV Contacto Gerente',
    conditionsOfSaleOfSocialManager: 'CGV Gerente Social',
    titleTemplate: 'Espacio Cliente Ubiflow',
    personalInformation: 'Mi configuración',
    help: 'Ayuda',
    changeUser: 'Cambiar de usuario',
    warning: 'Attención',
    dactivateAdBlock: 'Parece que un bloqueador de anuncios impide que se muestren sus datos. Por favor de desactivarlo.',
    exportSuccess: 'Se está creando la exportación de sus datos, recibirá un correo electrónico tan pronto como esté disponible.',
    exportErrorAccess: 'No tienes acceso a esta función',
    exports: 'Mis Exportaciones',
    quotas: 'Administrar mis cuotas',
    sponsorshipImmo: '¡Apadrina a un profesional inmobiliario y recibe 50€ de tarjeta regalo! Haga clic para obtener más información !',
    sponsorshipVo: '¡Apadrina un coche profesional y recibe 50€ de tarjeta regalo! Haga clic para obtener más información !',
    socialNetworks: 'Redes sociales',
    contactsVisitesTitle: 'Visitas por anuncios',
    portalsSocialManagment: 'Distribución de redes sociales',
    annoncesCommerciaux: 'Anuncios por vendedor',
    socialReviews: 'Reseñas de clientes',
    statistics: 'Estadísticas'
  },
  popup: {
    oldCustomerArea: 'Cerrar antigua Área de Clientes'
  },
  routes: {
    homeTitle: 'Inicio',
    myAccountTitle: 'Mi configuración',
    localPresenceTitle: 'Posicionamiento web local',
    ubiflowProducts: 'Productos Ubiflow',
    contactUsTitle: 'Contacte con nosotros',
    tutorialsVideosTitle: 'Ayuda',
    myWebsiteTitle: 'Mi sitio web',
    conditionsOfSaleTitle: 'Condiciones generales de venta',
    conditionsOfSaleOfDiffusionTitle: 'Condiciones generales de venta difusión',
    conditionsOfSaleOfContactManagerTitle: 'Condiciones generales de venta contact Manager',
    globalIntegrationReport: 'Informe de integration global',
    globalDiffusionReport: 'Informe de difusión global',
    adsTitle: 'Anuncios',
    adsListTitle: 'Lista de los anuncios',
    createAdTitle: 'Crear un anuncio',
    createAdModelTitle: 'Crear un modelo',
    adDetailsTitle: 'Detalles de un anuncio',
    editAdTitle: 'Modificación de un anuncio',
    adsSelectionTitle: 'Selección de los anuncios',
    diffusionSelectionTitle: 'Selección de las difusiones',
    presenceReportTitle: 'Informe de presencia',
    contactManagerTitle: 'Contact Manager',
    contactsSynthesisDiffusionTitle: 'Síntesis de los contactos generados por mis difusiones',
    contactsGeneratedByPortalsTitle: 'Contactos generados por mis portales',
    contactsDetailsPerPortalTitle: 'Detalle de los contactos por portal',
    contactsGeneratedByAdsTitle: 'Contactos generados por mis anuncios',
    contactsDetailsPerAdTitle: 'Detalle de los contactos por anuncio',
    contactsGeneratedTitle: 'Contactos generados',
    demandeRapprochementDetailsPerPortalTitle: 'Solicitudes de contacto',
    contactsSynthesisTitle: 'Síntesis de los contactos',
    diffusionsListTitle: 'Lista de difusiones',
    diffusionSelogerTitle: 'Groupo Seloger',
    diffusionReportTitle: 'Informe de difusión',
    diffusionsPerAdTitle: 'Difusiones por anuncio',
    myAccountsTitle: 'Mis cuentas',
    comptes: 'Cuentas',
    diffusion: 'diffusion',
    program: 'Programas',
    lot: 'Lotes',
    exports: 'Mis exportaciones',
    quotas: 'Administrar los cuotas',
    contentLibrary: 'Mi biblioteca de contenido',
    PrivateNote: 'Nota privada del anuncio',
    managePosts: 'Gestionar mis publicaciones',
    editBienVendu: 'Administrar la propiedad vendida',
    newBienVendu: 'Creación de una propiedad vendida',
    socialNetworks: 'Mis redes sociales',
    ubiflowProductQualiforma: 'Formulario de calificación',
    portalsSocialManagmentTitle: 'Distribución de redes sociales',
    statistics: 'Estadísticas'
  },
  contact: { // contact form
    mainText: 'Tiene una pregunta sobre el uso de su Espacio Cliente, ' +
                  'necesita <strong>información sobre un producto</strong> o desea compartir con nuestro equipo ' +
                  'un <strong>retorno de experiencia</strong> y proponernos unas ' +
                  '<strong>ideas de evolución</strong>, contáctenos con el formulario que sigue.',
    object: 'Asunto de su mensaje *',
    objectOption1: 'Preguntar algo sobre un producto',
    objectOption2: 'Presentar un nuevo portal',
    objectOption3: 'Preguntar algo sobre su Espacio Cliente',
    objectOption4: 'Presentar una idea de evolución del Espacio Cliente',
    objectOption5: 'Otro',
    objectOption6: 'Solicitar ayuda',
    writeMessage: 'Escriba su mensaje *',
    writeMessagePlaceholder: 'Para ayudarnos a contestar de la mejor forma posible, si su pregunta está relacionada a ' +
                                 'un anuncio o una difusion, por favor de indicarnos la referencia del anuncio, el nombre del portal, etc.',
    name: 'Su nombre y apellido',
    email: 'Su correo *',
    phone: 'Su numéro de teléfono',
    sendEmailCopy: 'Enviar una copia a mi correo',
    send: 'Enviar mi solicitud',
    ruleObjectRequired: 'El asunto es mandatorio',
    ruleMessageRequired: 'El asunto es mandatorio',
    ruleEmailRequired: 'El correo es mandatorio',
    rulePhoneNumber: 'Acepta solo números',
    messageEmailSent: 'El correo ha sido enviado exitosamente',
    messageEmailError: 'Ocurrió un error'
  },
  contacts: { // Contact Manager
    noActivated: {
      title: 'Contact manager',
      title1: 'Esta funcionalidad no está activada en su suscripción',
      text1: '¿ Necesita controlar y accelerar las ventas hasta sus futuros clientes?<br />' +
                   '¿ Desea seguir con precisión todos los contactos que reciba de los portales ?',
      title2: 'Recuento y estadísticas',
      text2: 'Todos los contactos llegando de los portales de su multi-difusión, también de los portales ' +
                   'en los cuales difunde sin Ubiflow, están contabilizados día tras día. ' +
                   'Una tabla de resumen se envia cada semana.',
      title3: 'Almacenamiento de sus contactos',
      text3: 'En la sección « Contactos generados por mis difusiones », ' +
                    'tiene acceso a la lista completa y al histórico de todos sus propectos. ' +
                    'Un diseño adecuado, un campo de búsqueda, la posibilidad de ordenar por fecha, ' +
                    'exportación de la lista de contactos... Tantas herramientas para permitirle un seguimiento ' +
                    'a lo largo del tiempo y una explotación por su equipo.',
      title4: 'El contacto correcto a la persona correcta',
      text4: 'Los contactos se envian directamente al comercial indicado, si la referencia del anuncio permite identificarlo.',
      title5: 'Simplificación de una solicitud',
      text5: 'Los correos de los portales están estandarizados a un formato único, donde la información que le interesa ' +
                   'se puede ver rápidamente. Ya no se perderá en un flujo de correos diferentes para ' +
                   'encontrar sus solicitudes de contacto.',
      discover: 'Descubrir el producto',
      beContacted: 'Interesado en el producto? Ser contacto por un asesor.',
      emailSubject: 'Cliente {{advertiser}} : Contact Manager - Solicitud de contacto',
      emailContent: 'El cliente {{advertiser}} ({{companyName}}) hizo una solicitud de contacto desde el nuevo ' +
                'espacio cliente para la solución "Contact Manager". Lo puede recontactar ' +
                'via {{email}} o al número {{phoneNumber}}',
      dialogMessage: 'Desea información sobre nuestro producto Contact Manager. Nuestro equipo lo contactará lo más pronto posible.',
      listUniqueContacts: 'Contactos únicos'
    },
    generatedByPortals: 'Contactos generados por mis portales',
    generatedByAds: 'Contactos generados por mis anuncios',
    accessToCockpit: 'Acceder a Cockpit',
    accumulatedIndicators: 'Indicadores de activitad cumulados en el periodo corriente',
    exportEmailContacts: 'Exportar los contactos por correo',
    exportPhoneContacts: 'Exportar los contactos por llamada',
    exportResults: 'Exportar los resultados',
    generatedContactsTotal: 'contacto generado (total)',
    generatedContactsTotal_plural: 'contactos generados (total)',
    tooltipTotal: 'Por los anuncios difundidos y no difundidos',
    generatedContactsActiveAds: 'contacto generado (anuncios activos)',
    generatedContactsActiveAds_plural: 'contactos generados (anuncios activos)',
    tooltipActiveAds: 'Contactos generados por los anuncios actualmente difundidos',
    contactsByEmail: 'Contactos por correo',
    contactsByPhone: 'Contacts por llamada',
    adsSent: 'Anuncio difundido',
    adsSent_plural: 'Anuncios difundidos',
    activePortals: 'Portal activo',
    activePortals_plural: 'Portales activos',
    activityDistributionTitle: 'Repartición de la actividad en el periodo corriente para los anuncios actualmente difundidos',
    activityDistributionEmailContacts: 'Repartición contactos correo (anuncios difundidos)',
    activityDistributionNoData: 'Sin datos para este periodo',
    activityDistributionOffers: 'Ofertas',
    activityDistributionProperties: 'Bienes',
    activityDistributionPortals: 'Portals',
    contactDetailsTitle: 'Detalles de los contactos recibidos',
    activityDistributionTitleVO: 'Distribución de los contactos generados durante el período actual sobre los anuncios que se difunden',
    contactDetailsLastMonths: '12 últimos meses',
    contactDetailsLastDays: '30 últimos días',
    listGeneratedContactsTotal: 'Total de los contactos generados',
    listDemandesRapprochementTotal: 'Total de solicitudes de contacto',
    listGeneratedProspectsTotal: 'Total de los propectos generados',
    listGeneratedCallContactsTotal: 'Total de los contactos por llamada',
    listGeneratedEmailContactsTotal: 'Total de los contactos por correo',
    listTooltipTotal: 'Por los anuncios difundidos y no difundidos',
    listGeneratedContactsMail: 'Contactos por correo generados',
    listTooltipMail: 'Contactos por correo generados por los anuncios actualmente difundidos',
    listGeneratedContactsAds: 'Contactos generados por los anuncios actualmente difundidos',
    listAdsSentContacts: 'Contactos generados (anuncios difundidos)',
    listAdsSent: 'Total de anuncios difundidos',
    listActivePortals: 'Total de portales activos',
    listPortalsEquippedWithCM: 'Portales equipados con Contact Manager',
    listGraphNoData: 'Sin datos para este periodo',
    listGraphDistributionByMail: 'Repartición de los contactos por correo',
    listGraphAdsSent: 'annuncios difundidos',
    listGraphAdsSentDistribution: 'Repartición (anuncios difundidos)',
    listTableNoData: 'Sin datos para este periodo',
    listTablePropertyTypes: 'Tipos de bienes',
    listTableOfferTypes: 'Tipos de ofertas',
    listColumnLogo: 'Logo',
    listColumnPortal: 'Nombre portal',
    listColumnBusinessModel: 'Modelo éconómico',
    listColumnContactsTotal: 'Total contactos',
    listColumnContactsMail: 'Contactos correo',
    listColumnContactsTel: 'Contactos llamada',
    listColumnAds: 'Anuncios',
    listColumnAdsNoActiveDiffusion: 'Sin difusión activa',
    listColumnTooltipAdNoSent: 'Este anuncio no está o ya no está difundido',
    listColumnAd: 'Anuncio',
    listColumnReference: 'Réferencia',
    listColumnActivePortals: 'Portales activos',
    listColumnContacts: 'Contactos',
    listColumnDate: 'Fecha',
    listColumnDateAndHour: 'Fecha y hora',
    listColumnAdReference: 'Referencia anuncio',
    listColumnCivilityLastnameFirstname: 'Civilidad, apellido, nombre',
    listColumnEmail: 'Correo',
    listColumnScoring: 'Puntuación',
    listColumnPhoneNumber: 'Teléfono',
    listColumnFormLink: 'Detalles del formulario',
    listColumnCallStatus: 'Estatus de la llamada',
    listColumnCallDuration: 'Duración de la llamada',
    listColumnDemandesRapprochement: 'Solicitudes de contacto',
    listTabMailtracking: 'Mail tracking',
    listTabMailtrackingPostalCode: 'Código postal',
    listTabMailtrackingCity: 'Ciudad',
    listTabMailtrackingAdAddress: 'Dirección del anuncio',
    listTabMailtrackingNoInformation: 'No especificado',
    listTabCalltracking: 'Call tracking',
    listTabCalltrackingCallAnswered: 'Llamada atendida',
    listTabCalltrackingCallMissed: 'Llamada perdida',
    listUniqueAds: 'Annuncios únicos',
    toolTipAdNotDiffused: 'Este anuncio ya no está difundido',
    generalInformation: 'Informaciones generales',
    postReference: 'Referencia',
    postPrice: 'Precio',
    postLocation: 'Localización',
    postEmptyField: 'Este campo está vacío',
    buttonContactsByPortal: 'Contactos por portal',
    buttonContactsByAd: 'Contactos por anuncio',
    buttonContactsAll: 'Todos los contactos',
    buttonContactsVisites: 'Visitas por anuncio',
    filenameExportContactsPortals: 'contactos_portales',
    filenameExportContactsAds: 'contactos_anuncios',
    filenameExportContactsPerPortal: 'contactos_por_portal',
    filenameExportContactsPerAd: 'contactos_anuncio',
    filenameExportContactsCalls: 'contactos_calltracking',
    filenameExportContacts: 'resumen_contactos',
    contactGenere: 'contactos generados',
    listTooltipUniqueAds: 'Número de anuncios únicos afectados por contactos',
    visites: {
      columnDateVisite: 'Fecha y hora de la visita',
      columnAdReference: 'Referencia',
      columnJaugeVisite: 'Número de inscritos / Número máximo de visitantes',
      columnNbAttente: 'Número de candidatos en espera',
      columnListeCandidatsExport: 'Lista de candidatos',
      columnAdStatut: 'Estado del anuncio',
      searchByReference: 'Buscar por referencia',
      adActive: 'Activo',
      adInactive: 'Inactivo'
    }
  },
  quotas: {
    validerQuotas: 'CONFIRMAR ESTA REPARTICIÓN DE LOS CUOTAS',
    repartitionQuotas: 'Repartir los cuotas de manera igual',
    total: 'Total',
    portails: 'Portales',
    succesUpdate: 'Sus cuotas han sido modificados.',
    quotaPerso: 'Cuota personal',
    txtPresentationQuota: 'Desde aquí puede configurar la repartición de sus cuotas de difusión por usario. La puede modificar manualmente o optar por una repartición equitable.',
    txtAucunQuota: 'No se pueden mostrar datos, ya sea porque todas sus difusiones están en estado "ilimitado" o porque ningún usuario tiene un stock de anuncios.',
    max: 'Cuota máx',
    tooltipsTotalQuotas: 'Total de anuncios difundidos / cuotas totales asignadas'
  },
  website: {
    title: 'Página Web',
    functionalityNoActivated: 'Esta funcionalidad no está activada en su subscripción.',
    contactUs: 'Contáctenos'
  },
  presenceLocale: {
    title: 'Solución Se Faire Connaître',
    text1: 'Haz que tu negocio brille localmente y avanza en la relación con tus futuros clientes gracias a nuestra oferta de ',
    keywordText1: 'SEO local.',
    text2Bold: '1 - Mejora tu visibilidad local en Internet.',
    text2: 'Nuestra solución permite distribuir de forma automática, y sin ningún esfuerzo por su parte, la información de su(s) punto(s) de venta en los 16 soportes de nuestro catálogo (Google, Maps, Facebook, Waze, Foursquare, . . .)',
    text3Bold: '2 - Destaca tu actividad',
    text3: 'Gracias a nuestra función, administre sus publicaciones desde un solo lugar y distribúyalas en los 3 medios más grandes: \n Google, Facebook e Instagram.',
    keywordText3: 'La Inteligencia Artificial',
    suiteText3: 'se involucra y te ayuda a producir contenido variado y de calidad.',
    text4Bold: '3 - Manténgase en contacto con su comunidad y administre su reputación electrónica',
    text4: 'Además de mantener informados a tus usuarios y potenciales clientes, mantén un vínculo permanente con ellos, recibe alertas cuando te dejen un comentario en Google y Facebook. La Inteligencia Artificial te acompaña para responder con la mayor precisión y de forma personalizada.',
    text5Bold: '4 - Organiza y anticipa tu comunicación',
    text5: 'Una herramienta de programación le permite agilizar su presencia en los medios y ahorrar un tiempo valioso.',
    text6: 'Así que es hora de ceñirse a los usos de los clientes que te buscan en Internet y en las redes sociales. \no',
    text7: 'En resumen, con nuestra solución SEO local,',
    cashPhrase: ' ¡te buscamos, te encontramos!',
    beContacted: 'Ser contacto por un asesor',
    alreadyClient: '¿ Ya tiene una cuenta ? Conéctese a su espacio cliente.',
    emailSubject: 'Client {{advertiser}} : Se faire connaitre - Solicitud de contacto',
    emailContent: 'El cliente {{advertiser}} ({{companyName}}) hizo una solicitud de contacto desde el nuevo ' +
            'espacio cliente para la solución "Se faire connaitre". Lo puede recontactar ' +
            'via {{email}} o al número {{phoneNumber}}',
    dialogMessage: 'Desea información sobre nuestro producto Contact Manager. Nuestro equipo lo contactará lo más pronto posible.',
    txtAccesTeteDeReseau: '<p class="text-justify">Su red tiene una subscripción a la solución "Se Faire Connaïtre".</p>\n' +
            '<p class="text-justify">Pero la gestión de está subscripción y el acceso a la interfaz "Se Faire Connaïtre" están limitados a su cabeza de red.</p>\n' +
            '<p class="text-justify">Entonces su punto de venta no puede accederlo. Para cualquier pregunta, por favor de contactar directament a su cabeza de red.</p>'
  },
  socialNetworkPosts: {
    title: 'Gestión de publicaciones',
    text1: 'Gracias a nuestra oferta de distribución en redes sociales y Google Business Profil: \n',
    text2: 'Optimizar el contenido en las primeras redes sociales y los primeros medios,',
    text3: 'Mejore la referenciación natural de su sitio y las visitas a sus puntos de venta,',
    text4: 'Desarrollar tu comunidad, nuevos puntos de interacción y por ende nuevas oportunidades de negocio,',
    text5: 'Distribuya su cartera de anuncios más ampliamente,',
    text6: 'Y mejore sus anuncios clasificados de acuerdo con las mejores prácticas apreciadas por cada uno de los medios.',
    text7: '¿Qué medios son?',
    beContacted: '¿Estás interesado y quieres saber más? Ser contactado por su representante de ventas.',
    emailSubject: 'Cliente {{anunciante}}: Redes sociales - Nueva solicitud de contacto desde el área de Cliente',
    emailContent: 'El cliente {{anunciante}} ({{companyName}}) realizó una solicitud desde su área de clientes. Quiere más información sobre nuestra oferta de redes sociales y pide ser contactado por el representante de ventas siguiendo su caso.',
    dialogMessage: '¿Desea información sobre nuestra solución de gestión de correos? Nuestro equipo se pondrá en contacto contigo lo antes posible.',
    alreadyClient: '¿Ya está equipado con la solución? Accede a la página de gestión de tus anuncios.'
  },
  validator: {
    usernameRequired: 'El nombre de usuario es mandatorio',
    passwordRequired: 'La contraseña es mandatoria',
    passwordConfirmationRequired: 'La confirmación de la contraseña es mandatoria',
    passwordMustBeEquals: 'Las contraseñas deben ser iguales',
    plate: {
      letterIandOnotAllowed: 'Las letras I y O no son acceptadas.',
      invalid: 'La matrícula no es valida.',
      sivFormat: 'Después de 2009, la matrícula debe respetar el formato SIV (AA-999-BB)',
      sivOrFniFormat: 'La matrícula debe respetar el formato FNI (1234 AB 35) o SIV (AA-999-BB)'
    },
    alertMandatoryFields: 'Por favor de llenar todos los campos necesarios',
    offerTypeRequired: 'El tipo de oferta es mandatorio',
    propertyTypeRequired: 'El tipo de propriedad es mandatorio',
    referenceRequired: 'La referencia es mandatoria',
    referenceMustBeWithoutAccentAndSpecialCharacter: 'La referencia no es válida. No se aceptan acentos ni caracteres especiales.',
    titleRequired: 'El título es mandatorio',
    priceRequired: 'El precio es mandatorio',
    priceMustBeNumber: 'El precio debe ser un número',
    monthlyRentRequired: 'El alquiler mensual es mandatorio',
    monthlyRentMustBeNumber: 'El alquiler debe ser un número',
    showPriceRequired: 'Indicar si desea mostrar el precio',
    textRequired: 'La descripción del anuncio es mandatoria',
    textAtLeast: 'Un mínimo de {{ number }} caracteres es requerido',
    realPostalCodeRequired: 'El código postal real es mandatorio',
    realCityRequired: 'La ciudad real es mandatoria',
    postalCodeRequired: 'El código postal es mandatorio',
    cityToShowRequired: 'La ciudad es mandatoria',
    mustBeNumber: 'Este campo debe ser un número',
    mustBeNumericValue: 'Este campo debe ser un un valor numérico',
    serialNumberAtLeast: 'El número de serie debe contener {{ number }} caracteres',
    brandRequired: 'La marca es mandatoria',
    modelRequired: 'El modelo es mandatorio',
    yearRequired: 'El año es mandatorio',
    versionRequired: 'La versión es mandatoria',
    mileageRequired: 'El kilometraje es mandatorio',
    energyRequired: 'La energia es mandatoria',
    offerTitleMax: '{{ number }} caracteres máximo',
    corporateNameRequired: 'La razón social es mandatoria',
    wrongFormat: 'Formato equivocado',
    httpOrHttps: 'Este campo debe empezar con http:// o https://',
    referenceAlreadyExists: 'La referencia de su anuncio ya existe',
    enterReference: 'Por favor de escribir una referencia',
    validEmail: 'Este campo debe ser un correo válido.',
    addDelete: 'Sus anuncios han sido eliminados',
    addDuplicate: 'Su anuncio ha sido duplicado',
    addUpdate: 'Su anuncio ha sido actualizado',
    addMerge: 'Su anuncio ha sido creado',
    isRequired: 'Este campo es obligatorio',
    errorReferenceExceed: 'La referencia de su anuncio no puede sobrepasar los 50 caracteres.'
  },
  error: {
    unknown: 'Se produjo un error desconocido.',
    found: 'Un error desconocido ha sido encontrado',
    gif: 'No se acepta el formato GIF',
    formatImage: 'No se acepta el formato {{ format }}'
  },
  components: {
    lists: {
      resultsPerPage: 'Resultatos por página : ',
      sortByPlaceholder: 'Ordenar por...',
      sortByLabel: 'Ordenar por {{ label }}',
      resultsFromTo: 'Resultados {{ from }} hasta {{ to }} sobre {{ total }}',
      noResult: 'Ningún resultado',
      loading: 'Cargando...',
      eraseSelection: 'Borrar la selección',
      selectAll: 'Seleccionar todo',
      columnThumbnails: 'Fotos',
      valide: 'Válido',
      diffusee: 'Transmisión',
      errorOnLoading: 'Se produjo un error al cargar esta página'
    },
    card: {
      activated: 'Activado',
      deactivated: 'Desactivado',
      postFlux: 'Este anuncio debe eliminarse en su software y no en su Espacio Cliente Ubiflow',
      draft: 'Borrador',
      model: 'MODELO',
      createdOn: 'Creado el',
      updatedOn: 'Modificado el'
    },
    searchContainer: {
      hideFilters: 'Esconder los filtros',
      showFilters: 'Mostrar los filtros',
      search: 'Buscar',
      orFilterBy: 'o filtrar por :',
      advancedSearch: 'Búsqueda avanzada'
    },
    facebook: {
      label: 'Conexión Facebook'
    }
  },
  posts: {
    list: {
      pageTitleLots: 'Lista de lotes',
      pageTitlePrograms: 'Lista de programas',
      pageTitleAds: 'Lista de anuncios',
      backToProgramList: 'Regresar a la lista de programas',
      backToAdsList: 'Volver a la lista de programas',
      backToPostsList: 'Volver a la lista de publicaciones',
      createLot: 'Crear un lote',
      createProgram: 'Crear un programma',
      createAd: 'Crear un anuncio',
      createAdFromModel: 'Crear un anuncio desde un modelo',
      createProgamFromModel: 'Crear un programa desde un modelo',
      createlotFromModel: 'Crear un lote desde un modelo',
      createLand: 'Crear un terreno',
      createModel: 'Crear un modelo',
      createPost: 'Create un puesto',
      filenameExportAds: 'lista_anuncios',
      delete: 'borrar',
      postsCity: 'Ciudad',
      diffuseLater: {
        title: 'Programe la difusión de su anuncio',
        text: 'Para que fecha quiere programar su difusión ?',
        subText: 'Si quiere difundir su anuncio ahora, activelo desde la lista de anuncios.',
        diffusedAt: 'Difusión el :',
        diffusionConfirmedFirstPart: 'Su anuncio será publicado el ',
        diffusionConfirmedSecondPart: '. Mientras, se guardará como borrador y seguirá editable. Será redireccionado a su lista de anuncios.',
        planDiffusion: 'Programar la difusión',
        reportDiffusion: 'Cambiar la programación'
      },
      contentLibrary: 'Mi biblioteca de contenido',
      informationBienVendu: 'Información del inmueble vendido',
      declarePostAsDeleteByNo: 'No, eliminar la propiedad',
      declarePostAsSoldByYes: 'Sí, vendí la propiedad.',
      bienVendu: 'Propiedad vendida',
      newBienVendu: 'Crear una propiedad vendidad',
      daysRemaining: 'días restantes',
      commercial: 'Comercial',
      nbAnnonces: 'Anuncios activos',
      annoncesActivesDecroissantes: 'anuncios decrecientes',
      annoncesActivesCroissantes: 'anuncios en crecimiento',
      commercialDecroissant: 'comercio decreciente',
      commercialCroissant: 'negocio en crecimiento',
      graphAnnoncesCommerciauxTitle: 'Distribución del número de anuncios activos por vendedor',
      graphAnnoncesCommerciauxNoData: 'Sin datos',
      graphAnnoncesCommerciauxSubtitle: 'Anuncios activos'
    },
    dialog: {
      duplicateTitle: 'Duplicar su anuncio',
      duplicateText: '¿ Está seguro de querer duplicar su anuncio ?',
      duplicateReference: 'Escriba una referencia para su anuncio duplicado (opcional) : ',
      duplicatePlaceholder: 'Escriba una referencia para su anuncio duplicado (opcional)',
      duplicateNotificationSuccess: 'Su anuncio ha sido duplicado con la referencia {{ reference }}',
      duplicateNotificationError: 'Se produjo un error durante la duplicación de su anuncio',
      deleteTitle: 'Borrar su anuncio',
      deleteText: '¿ Está seguro de querer borrar su anuncio ?',
      deleteTextSoldProductOption: 'Quiere eliminar este anuncio. ¿Esta propiedad fue vendida por usted?',
      deleteNotification: 'Su anuncio ha sido borrado',
      modelDeleteTitle: 'Borrar modelo',
      modelDeleteText: '¿ Está seguro de querer borrar este modelo ?',
      selectModelTitle: 'Seleccionar entre sus modelos existentes siguientes',
      selectModelTitleCmiste: '¿Le gustaría utilizar un model para crear su anuncio?',
      selectModel: 'Seleccione un modelo',
      selectModelProgram: 'O seleccionar un programa',
      selectTerrain: 'Seleccione un terreno',
      selectListTerrain: 'Seleccione de su lista de terrenos',
      selectListModel: 'Seleccione de su lista de modelos',
      propertyType: 'Seleccione un tipo de propiedad',
      createFromModelTitle: 'Crear un anuncio desde este modelo',
      createFromModelText: '¿ Está seguro de querer crear un anuncio desde su modelo ?',
      selectReference: 'Escriba una referencia para su anuncio creado ',
      selectReferencePlaceholder: 'Escriba una referencia para su anuncio creado',
      textCreateLot: "Pour créer un lot, veuillez choisir le programme auquel le rattacher dans la liste ci-dessous puis cliquer sur le bouton \"Gérer les lots. Vous aurez ensuite la possibilité de créer un lot à partir d'un modèle, retourner à la liste des programmes, créer un nouveau lot et consulter la liste des lots déjà rattachée à ce programme.",
      confirm: 'Confirmar',
      delete: 'Borrar',
      cancel: 'Cancelar',
      selectProgram: 'Elija el programa al que desea adjuntar su lote.',
      choiceOfProgram: 'Selección del programa',
      lengthSelectedExceeded: 'La longitud de su selección excede {{length}} anuncios',
      archiveMyPost: 'Archivar mi anuncio',
      dontDisplayAnymore: 'No mostrar',
      close: 'Cercar',
      unPublishNOK: 'Su anuncio debe estar sin publicar antes de que pueda archivarlo de forma permanente.',
      archiveConfirm: 'El archivo de un anuncio de propiedad vendida es definitivo e irreversible. El anuncio ya no estará accesible en su Área de Cliente. ¿Confirma el archivo de este anuncio?'
    },
    card: {
      model: 'Modelo',
      ref: 'Ref',
      actionsOnThisAd: 'Acciones sobre este anuncio',
      seeLots: 'Ver los lotes',
      manageLots: 'Gestionar los lotes',
      details: 'Detalles',
      edit: 'Editar',
      diffuse: 'Difundir',
      duplicate: 'Duplicar',
      useThisModel: 'Usar este modelo',
      useThisLand: 'Usar este terreno',
      presenceReport: 'Informe de presencia',
      delete: 'Borrar',
      contacts: 'Contactos',
      privateNote: 'Nota privada',
      managePosts: 'Posts',
      noData: 'No hay datos disponibles en este momento...',
      selectAll: 'Seleccionar todo',
      deSelectAll: 'Deseleccionar todo',
      reference: 'Referencia',
      title: 'Título'
    },
    components: {
      picturesTitle: 'Fotos',
      picturesText: 'Gestionar aquí las fotos de su propiedad. <strong>La primera foto activada corresponde ' +
                'a la foto principal de su anuncio y al publicar en las redes sociales.</strong>',
      picturesButton: 'Agregar una o varias fotos',
      picturesDialogTitle: 'Seleccionar el origen de sus fotos a agregar...',
      picturesDialogTextTop: 'Desde su computadora o dispositivo móvil',
      picturesDialogTextMiddle: '<em>Haga clic aquí</em> o arrastre y suelte los archivos',
      picturesDialogTextBottom: 'Archivos jpg/png con un tamaño inferior a 10Mo <br> 50 fotos máximo',
      picturesButtonCancel: 'Cancelar',
      picturesButtonAdd: 'Agregar las fotos',
      picturesButtonDelete: 'Borrar',
      otherMediasTitle: 'Medias adicionales',
      otherMediasText: 'Escriba la ubicación de los diferetentes medias adicionales.',
      otherMediasVirtualVisit: 'Visita virtual',
      otherMedias: 'Otros media',
      otherMediasTxt: 'Agregue una URL que redireccione a otro medio en línea (animación, video, ...)',
      otherMediasVirtualVisitText: 'Agregar una URL hasta la página presentando una visita virtual de la propiedad',
      otherMediasTestLink: 'Probar el enlace',
      otherMediasAttachedFiles: 'Archivos adjuntos',
      otherMediasAttachedFilesText: 'Insertar unos archivos adjuntos desde su computadora o su dispositivo móvil',
      otherMediasAttachedFilesButton: 'Agregar un archivo adjunto',
      customizedFormElement: 'Elemento de formulario personalizado',
      postalCodePlaceholder: 'Ex : 97132',
      cityPlaceholder: 'Ex : Issy-les-Moulineaux',
      adPerformance: 'Rendimiento del anuncio',
      forMoreInformation: 'Para mas información contacte ',
      urlVideo: 'URL del vídeo'
    },
    edit: {
      achat: 'Compra',
      loa: 'Arrendamiento con opción a compra',
      lld: 'Alquiler a largo plazo',
      loyerMontantVo: 'La renta',
      dureeLocationLoa: 'Periodo de alquiler',
      kilometrageMaxLoa: 'kilometraje máximo',
      kilometrageAutomatic: 'Para vehículos nuevos, el kilometraje se pone automáticamente a 0',
      financementApport: 'Monto de la contribución',
      servicesInclusLoyer: 'Servicios incluidos en la renta',
      urlMentionsLegalesLoa: 'Enlace a la URL del aviso legal',
      legalNotices: {
        dialogDeleteTitle: 'Borrar las menciones legales seleccionadas',
        dialogDeleteText: '¿ Está seguro de querer borrar esas menciones legales ?',
        dialogUpdateTitle: 'Modificar el modelo de menciones legales seleccionado',
        dialogUpdateNoticesTitle: 'Título de sus menciones legales',
        dialogUpdateNoticesText: 'Texto de sus menciones legales',
        dialogButtonCancel: 'Cancelar',
        dialogButtonConfirm: 'Confirmar',
        dialogButtonUpdateOnlyForThisAd: 'Utilizar únicamente para este anuncio',
        dialogButtonUpdateModel: 'Actualizar el modelo',
        title: 'Menciones legales de la oferta',
        description: 'Para agregar unas menciones legales a su anuncio, puede seleccionar en una lista de modelos existentes o ' +
                    'puede crear nuevas menciones legales que también puede guardar como modelo.',
        chooseModel: 'Seleccione un modelo',
        chooseModelPlaceholder: 'Seleccione en su lista de menciones legales',
        buttonUse: 'Utilizar',
        buttonSave: 'Guardar',
        buttonEdit: 'Editar',
        tooltipUse: 'Haciendo clic en "Utilizar" decide utilizar esas menciones legales par su anuncio actual. ',
        tooltipSave: 'Haciendo clic en "Guardar", decide utilizar esas menciones legales par su anuncio actual ' +
                    'y guardarlas como nuevo modelo',
        selectedNoticesText: 'Texto de las menciones legales seleccionadas',
        orCreateNoticesText: 'O crea sus menciones legales',
        newNoticesTitle: 'Título de sus menciones legales',
        newNoticesText: 'Texto de sus menciones legales',
        messageSuccess: 'Las menciones legales han sido agregadas exitosamente al texto de su anuncio que puede ver en la pestaña ' +
                    '"Información principal". Le invitamos a verificarlas antes de validar su anuncio para difusión.',
        messageDeleteSuccess: 'Las menciones legales seleccionadas han sido borradas exitosamente',
        messageDeleteError: 'Hubo un problema durante la supresión de sus menciones legales',
        messageEmptySelection: 'No ha seleccionado menciones legales',
        messageUpdateError: 'Hubo un problema durante la actualización de sus menciones legales'
      },
      publish: 'Publicado',
      now: 'Ahora',
      scheduled: 'planificado',
      spread: 'Transmisión',
      deleteSchedule: 'Eliminar horario',
      deletePlanning: 'Eliminar horario',
      beneficieTVA7: 'IVA del 7% aplicada',
      beneficieTVA5: 'IVA del 5.5% aplicada',
      save: 'Guardar',
      saveModifications: 'Guardar las modificaciones',
      saveDraft: 'Guardar como borrador',
      createModel: 'Crear como modelo',
      createAsLand: 'Crear como terreno',
      deleteModel: 'Borrar el modelo',
      deleteLand: 'Borrar el terreno',
      cancel: 'Cancelar',
      pageTitleLot: 'Crear un lote',
      pageTitleProgram: 'Crear un programa',
      pageTitleModele: 'Editar una plantilla',
      pageTitleAd: 'Crear un anuncio',
      alertBeforeLeave: '¿ Está seguro de querer quitar la edición de su anuncio ? Todas las modificaciones serán perdidas.',
      mainInformationTitle: 'Informaciones principales',
      fuel: 'gasolina',
      electric: 'eléctrico',
      moreInformationTitle: 'Información complementaria',
      mainInformationText: 'Todos los campos son mandatorios. Permiten determinar las grandes características de ' +
                'su anuncio. <br><br> Llenar los campos siguientes para poder publicar su anuncio :',
      offerType: 'Tipo de oferta',
      propertyType: 'Tipo de propiedad',
      reference: 'Referencia del anuncio',
      tooltipReference: 'Cuidado: con el fin de respetar las reglas de publicaciones de los portales, ' +
                'le aconsejamos no sobrepasar los 20 caracteres para esta referencia.',
      tooltipEquipementsAndOptions: 'Cuidado: los equipamientos deben agregarse manualmente usando la lista proporcionada. ' +
                '<br/> El objectivo de este campo es de completar los equipamientos agregados. ' +
                '<br/> Por favor de separar los equipamientos complementarios con una coma. ' +
                '<br/> Por favor de no escribir frases, hacer copiar-pegar o usar otros signos de puntuación.',
      title: 'Título del anuncio',
      vehiculeImporte: 'Permite indicar que se trata de un vehículo importado y la matrícula extranjera.',
      informationsComplementaires: 'Este campo no debe contener el equipo, sino información adicional como servicios al momento de la compra, detalles de costos al momento de la venta o información sobre el punto de venta',
      price: 'Precio',
      priceIncludingVAT: 'Precio IVA incluido',
      priceExcludingVAT: 'Precio sin impuestos',
      rent: 'Alquiler',
      obligationToClearBrush: 'Obligación de limpiar la maleza',
      description: 'Descripción',
      adText: 'Texto del anuncio',
      vehicleType: 'Tipo de vehículo',
      warranty: 'Garantia',
      location: 'Ubicación',
      locationProximityAndSituation: 'Proximidad y situación',
      locationPropertyTitle: 'Ubicación de la propiedad',
      locationPropertyText: 'Llenar la dirección de la propiedad y también la ubicación tal como desea verla en los ' +
                'anuncios. <br><br> Cuidado : Active la comunicación de la dirección exacta unicamente si ha respetado algunas reglas.',
      programType: 'Tipo de programa',
      selectTypePlaceholder: 'Seleccionar un tipo...',
      linkToProgramOnline: 'Enlace hasta el programa en linea',
      showPriceTooltip: 'Si no desea mostrar el precio de su propiedad, haga clic en "no" y será publicado "consultarnos"',
      typeLand: 'Terreno',
      typeLandHouse: 'Programa de terreno + casa',
      mergeFromModels: 'Crear desde la biblioteca de contenido',
      address: 'Dirección',
      programAddressTitle: 'Dirección del programa',
      programAddressText: 'Indicar la ubicación del programa tal como desea verla en los ' +
                'anuncios. <br><br>Cuidado : Active la comunicación de la dirección exacta unicamente si ' +
                'ha respetado algunas reglas.',
      exactAddressTooltip: "Si selecciona 'Sí', la ubicación exacta de su propiedad será visible en el anuncio. " +
                'De lo contrario, le ofrecemos mencionar unicamente la ciudad.',
      locationToPublishTitle: 'Ubicación a publicar',
      locationToPublishTooltip: 'Estos datos serán los publicados en los portales, para permitir la ubicación de su propiedad.',
      locationToPublishTooltipVo: "La información 'Código postal' y 'Ciudad' permitten un mejor " +
                '<br/>enriquecimiento de la ubicación de su anuncio pero no serán ' +
                '<br/>publicados en los portales. Los puede llenar si están differentes ' +
                '<br/>de la información que desea publicar en internet.',
      interiorTitle: 'Interior',
      interiorServices: 'Prestaciones interiores',
      otherInteriorServices: 'Otros servicios interiores',
      exteriorServices: 'Prestaciones exteriores',
      exactAddressTitle: 'Dirección exacta',
      saleDetailsTitle: 'Detalles de comercialización',
      target: 'Objetivo',
      virginDPEMessage: 'De forma excepcional […] en la ausencia justificada de sus registros de consumo, los elementos requeridos […] deben quedar en blanco.',
      contactTitle: 'Información de contacto',
      contactText: 'Indicar la información de contacto que desea publicar.',
      contactFirstnameLastname: 'Nombre/Apellido',
      internationalTitle: 'internacional',
      saleTitle: 'Solicitud de venta de propiedad',
      saleTitleShort: 'Venta',
      saleNewTitle: 'Venta nuevo',
      leaseTransferTitle: 'lease transfer',
      goodwillTitle: 'Fondo de comercio',
      tariffTitle: 'Tarifa',
      auctionsTitle: 'Subasta',
      rentalTitle: 'Alquiler',
      saleRentalTitle: 'Venta o alquiler',
      fillAdPriceDetails: 'Indicar la información sobre precios de su anuncio.',
      copropertyTitle: 'Copropriedad',
      fillCopropertyInformation: 'Indicar la información si la propriedad está sometida al estatus de copropiedad.',
      mandateTitle: 'Mandato',
      fillMandateInformation: 'Indicar la información sobre el mandato de esta propiedad.',
      equipmentsAndOptionsTitle: 'Equipos y opciones',
      equipmentsAndOptionsText1: 'Para enriquecer su anuncio, puede seleccionar los equipos y opciones de la lista personalizable o utilizar el campo libre.',
      equipmentsAndOptionsText2: 'Unas sugerencias aparecerán automáticamente de acuerdo a las primeras letras de su búsqueda.',
      vehicleDescriptionLBC: 'Este campo es específico de la distribución Le Bon Coin que ahora permite la publicación de una descripción gratuita del vehículo',
      lookForEquipmentPlaceholder: 'Buscar un equipo',
      seeAvailableEquipmentsList: 'Ver la lista de equipos disponibles',
      customizeFavoriteEquipment: 'Personaliza tu equipo favorito',
      availableEquipmentsList: 'Lista de equipos disponibles',
      maxFavoriteEquipments: 'Número de equipos seleccionados como favoritos',
      maxFavoriteEquipmentsTip: 'Máximo {{ max }}',
      otherInformation: 'Otros datos',
      tabMain: 'Información principal',
      tabDetail: 'Detalle de la oferta (precio, mandato...)',
      tabDetailProgram: 'Detalle del programa',
      tabEquipments: 'Equipos y opciones',
      tabDescription: 'Descripción de la propiedad',
      tabMedias: 'Medias (Fotos, videos...)',
      tabInstagram: 'Difusión Instagram',
      tabLegalNotices: 'Menciones legales',
      tabInternational: 'Internacional (textos traducidos)',
      tabParametres: 'Configuración de anuncios',
      copropertyAverageAnnualFee: 'Monto anual promedio de los gastos de copropiedad',
      copropertyMonthlyFee: 'Monto mensual de cuotas de condominio',
      intercabinetCommission: 'Commisión entre-gabinetes',
      withoutCivilityAndName: '(sin civilidad y sin nombre)',
      landlordAddress: 'Dirección del propietario',
      landlordOtherInformation: 'Otra información',
      realPropertyPostalCode: 'Código postal real de la propiedad',
      realPropertyCity: 'Ciudad real de la propiedad',
      goodwillPrice: 'Precio del fondo de comercio',
      goodwillWallsRental: 'Alquiler de los muros',
      landPricePart: 'Parte correspondiente al precio del terreno',
      ancillaryCostsPart: 'Parte correspondiente a los gastos conexos',
      includingTaxes: 'incluiendo IVA',
      recoveryCondition: 'Modalidad de recuperación',
      rentalFeeIncludingConditionInspection: 'Honorarios (honorarios el inventario incluido)',
      linkToAgencyFees: 'Enlace hasta las tarifas de la agencia',
      collateralSecurityRequired: 'Necesita garantía solidaria',
      seller: 'Vendedor',
      buyer: 'Comprador',
      costsWillBeBorneBy: 'Honorarios a cargo del ...',
      sellerShare: 'Cuota seller',
      buyerShare: 'Cuota buyer',
      package: 'Paquete',
      monthlyAnnuity: 'Ingreso mensual',
      land: 'Terreno',
      checkboxLandWithSlope: 'Con pendiente',
      checkboxLandServiced: 'Urbanizado',
      checkboxLandAllotment: 'En urbanización',
      checkboxLandBuildable: 'Edificable',
      propertyPartnerCompany: 'Empresa',
      propertyPartnerLastname: 'Apellido del contacto',
      propertyPartnerFirstname: 'Nombre del contacto',
      propertyPartnerPhone: 'Télefono',
      checkboxAirport: 'Aeropuerto',
      checkboxHighwayExit: 'Salida autopista',
      checkboxGare: 'Estación de tren',
      checkboxBus: 'Bus',
      checkboxTramway: 'Tram / tramway',
      checkboxParking: 'Estacionamiento',
      checkboxShops: 'Tiendas',
      checkboxMall: 'Centro comercial',
      checkboxDowntown: 'Centro de la ciudad',
      checkboxNursery: 'Guardería',
      checkboxPrimarySchool: 'Escuela primaria',
      checkboxCollege: 'Colegio',
      checkboxHighSchool: 'Liceo',
      checkboxUniversity: 'Universidad',
      checkboxGreenSpaces: 'Espacios verdes',
      checkboxSubway: 'Metro',
      cd: 'Radio CD',
      agencyFee: 'Gastos de agencia',
      diffuseNow: 'Guardar y difundir',
      diffuseLater: 'Guardar y programar mi difusión',
      adSaved: 'La información de su anuncio se guardó corectamente. Su anuncio será difundido el ',
      redirect: 'Será redirigido a su lista de anuncios.',
      adManagerTitle: 'Administrador de anuncios',
      adManagerText: 'Seleccione la persona a cargo de este anuncio en la lista desplegable. ' +
                '<br> Si la persona a la que desea asignar este anuncio no está presente en la lista, ' +
                'o es porque no tiene los derechos de acceso necesarios al Área de Clientes, ' +
                'o porque debe agregarla a su agenda de contactos',
      user: 'Usuario',
      createLand: 'Crear un terreno',
      model: 'Modelo',
      selectLand: 'Seleccione un modelo de terreno para construcción',
      selectModel: 'Seleccione un modelo de casa para construcción',
      instagramSubtitle: 'Edite desde esta pestaña los contenidos que se transmitirán en su post Instagram.' +
                '<br><br>Le ofrecemos un contenido para difundir que puede modificar. ' +
                'También puede volver a él haciendo clic en el botón « Regenerar ».' +
                "<br><br>Solo se puede transmitir su imagen principal de la pestaña 'Medios'<br><br><strong>ATTENTION</strong><br>",
      networkTextFormat: 'El formato de tus visuales debe adaptarse a esta red social.',
      instagramTextPost: '<strong>Once your post has been broadcast, its content will no longer be editable or deletable from your Ubiflow Customer Space.</strong>',
      instagramCaption: '2200 caracteres como máximo, incluyendo sus # (30 máximo), @ (20 máximo) y la liga hasta su anuncio. ' +
                'Para esta ultima, le recomendamos usar ligas reducidas, Google URL Shortener es una buena herramienta para eso.',
      alreadyBroadcastedToInstagram: 'Su anuncio ha sido enviado a su cuenta Instagram. Ya no se puede modificar.',
      shortDescription: 'Descripción breve',
      tooltipTexteResume: 'Esta descripción será considerada en su difusion hasta Google My Business si es parte de su subcripción.',
      generateInstagramCaption: 'Regenerar',
      generateCaption: 'Regenerar',
      resetCaption: 'Regenerar',
      instagramOptionDisabled: 'La difusión de sus anuncios en Instagram no está habilitada. Para ello, contáctenos al 02 99 83 05 36.',
      GMBOptionDisabled: 'La distribución de tus anuncios en Google My Business no está activada. Para ello, contáctenos al 02 99 83 05 36.',
      surfaceHabitable: 'Sala de estar',
      surfaceCommerciale: 'Area de ventas',
      surfaceActivite: 'Área de actividad',
      surfaceLand: 'Superficie del terreno ',
      promoterProgram: 'Programa inmobiliario',
      miseEnCirculation: 'Puesta en circulación',
      carDoorsAfter: ' puertas',
      warrantyTime: 'Período de garantía',
      idRPLS: 'Número RPLS',
      location_active: 'Alquiler activo',
      location_active_nud: 'Verificación de NUD de alquiler activo',
      editPostNonEditablesFieldsImmo: 'Los siguientes elementos no se pueden modificar durante la edición:<br>' +
                '<br><ul>' +
                '<li>Tipo de oferta</li>' +
                '<li>Tipo de propiedad</li>' +
                '<li>Referencia</li>' +
                '<li>Título del anuncio</li>' +
                '<li>Texto del anuncio</li></ul>',
      editPostNonEditablesFieldsVo: 'Los siguientes elementos no se pueden modificar durante la edición:<br>' +
                '<br><ul>' +
                '<li>Reference</li>' +
                '<li>Tipo de vehículo</li></ul>',
      changeMassContactsTitle: 'Seleccione de la lista desplegable el contacto que desea completar para los anuncios seleccionados : ',
      commercialEntityCode: 'Código de entidad comercial',
      formBienVenduTitle: 'Información sobre la venta de la propiedad',
      formBienVenduAnnonceTitle: 'Información relativa al anuncio de la propiedad',
      bienVenduSubtitle: 'Desde esta pestaña, complete la información principal sobre la propiedad que ha vendido. <br>' +
          '<br>' +
          '\n' +
          'Si desea comunicarse sobre este inmueble vendido, Ubiflow le ofrece para cada una de sus redes sociales, un post generado automáticamente en base a estos datos y el de su anuncio. <br>' +
          '<br>' +
          '\n' +
          'Puede editar estos datos y personalizar las publicaciones antes de que se publiquen en sus redes. <br>',
      prixVenduNet: 'precio de venta neto',
      GMBTitle: 'Información para publicar en Google My Business',
      GMBSubtitle: 'Edite su publicación desde esta pestaña como desea que aparezca en su página de Google My Business.\r\n' +
          '<br><br>' +
          'Ubiflow le ofrece una publicación generada automáticamente en función de los datos de su anuncio.\n' +
          'Puedes editarlo antes de que se publique.',
      GMBSubtitle2: 'Edite su publicación desde esta pestaña como desea que aparezca en su lista de empresas de GMB.<br><br>Ubiflow le ofrece una publicación generada automáticamente en función de los datos de su anuncio.<br>Puedes editarlo antes de que se publique.',
      creationBienVendu: 'Creación de una propiedad vendida',
      creationBienVenduDialogCaption: 'La incautación de información relativa a la venta de un inmueble, conduce automáticamente a la publicación' +
          ' el anuncio del inmueble en los distintos portales de distribución, si éste fuere publicado.',
      infoGeoRisques: 'Información de riesgo',
      geoRisquesSubtitle: 'Un decreto aplicable el 01/01/2023 dispone que el anuncio relativo a la venta o alquiler de bienes para los que debe establecerse la declaración de riesgos mencionada en el artículo L. 125-5, independientemente de su medio de difusión, incluye la siguiente declaración: La información sobre los riesgos a los que está expuesta esta propiedad está disponible en el sitio web de Georisks : <a href="https://www.georisques.gouv.fr" target="_blank">www.georisques.gouv.fr</a>',
      typeTransmission: 'Tipo de unidad',
      instagramMaxHashtagExceeded: 'Has superado el número de hashtags permitidos',
      instagramMaxMentionsExceeded: 'Has superado el número de hashtags permitidos',
      chars: 'caracteres',
      visite: {
        title: 'Visitas',
        description: '',
        duree_publication: 'Duración de la publicación',
        heures: 'horas',
        lieu_visite: 'Lugar de visita',
        commentaire: 'Comentario',
        visite: 'Visita',
        dateDebut: 'Fecha de la visita',
        horaire: 'Horario de la gira',
        nombre_candidats_max: 'Número máximo de visitantes',
        saveVisite: 'Guardar visita',
        nombre_candidats_inscrits: 'Número de candidatos registrados',
        status: 'Estado de la visita',
        statusActive: 'Activo',
        statusInactive: 'Inactivo',
        confirmationAnnulationTitle: 'Cancelar la visita',
        confirmationAnnulationText: '¿Le gustaría cancelar esta gira?',
        annuler: 'No',
        confirmer: 'Si'
      },
      activitesCommercePlaceholder: 'Elige una actividad'
    },
    view: {
      edit: 'Editar',
      sendByEmail: 'Enviar por correo',
      sendByEmailTitle: 'Transferir este anuncio por correo',
      sendByEmailRecipient: 'Correo del destinatario',
      sendByEmailMessage: 'Su mensaje',
      sendByEmailComment: 'Su anuncio en archivo adjunto',
      sendByEmailSubject: 'Su anuncio {{ postTitle }}',
      sendByEmailAttachment: 'Anuncio-{{ reference }}.pdf',
      cancel: 'Cancelar',
      send: 'Enviar',
      goBackTitleLots: 'Regresar a la lista de lotes',
      goBackTitlePrograms: 'Regresar a la lista de programas',
      goBackTitleAds: 'Regresar a la lista de anuncios',
      pageTitleLot: 'Detalle de un lote',
      pageTitleProgram: 'Detalle de un programa',
      pageTitleAd: 'Detalle de un anuncio',
      print: 'Imprimir',
      printFilename: 'Mi_Anuncio.pdf',
      name: 'Apellido : {{ name }}',
      city: 'Ciudad : {{ city }}',
      cityPromoteur: 'Ciudad : ',
      price: 'Precio : {{ price }} {{ currency }}',
      priceMin: 'Precio : desde {{ price }} {{ currency }}',
      priceLowSeason: 'Precio semanal temporada baja : {{ price }} {{ currency }}',
      priceMiddleSeason: 'Precio semanal temporada media : {{ price }} {{ currency }}',
      priceHighSeason: 'Precio semanal temporada alta : {{ price }} {{ currency }}',
      monthlyRentChargesIncluded: 'Gastos de alquiler mensuales incluidos',
      monthlyRentChargesIncludedDisplay: '€ / mes gi',
      priceContactUs: 'Precio : Consultarnos',
      surfaceMinMax: 'Superficie : desde {{ min }}m² hasta {{ max }}m²',
      surface: 'Superficie : {{ surface }}m²',
      roomsNumber: 'Número de habitaciones : {{ number }}',
      offerTypeV: 'Tipo de oferta : Venta',
      contactTitle: 'Información de contacto',
      saleConditionsPrice: 'Precio',
      saleConditionsPriceVo: 'Precio : {{ price }} {{ currency }}',
      saleConditionsLand: 'parte del precio del terreno',
      saleConditionsBuyerFee: 'Honorarios comprador IVA incluido',
      gearsNumber: '{{ number }} velocidades',
      selectionVoMarchand: 'Comerciante',
      selectionVo: 'Selección de voz',
      goBackTitleSelectionVo: 'Volver a la lista de selección de VO',
      contacter: 'Contactar con',
      sousGarantieConstructeur: 'Bajo la garantía del fabricante',
      contacterVendeur: 'Contacte al vendedor',
      emailReplyTo: 'Dirección de correo electrónico de respuesta',
      selectionVoEmailComment: 'Hola estoy interesado en el vehiculo de referencia \'{{ postRef }}\'',
      pricePublic: 'precio publico',
      priceDealer: 'precio de mercado',
      portalLink: 'Enlace del portal'
    },
    bienVendu: {
      createWarning: 'El ingreso de información relativa a la venta de un inmueble conduce automáticamente a la publicación del anuncio del inmueble en los distintos portales de distribución, si éste fuere publicado.',
      formDialogCreateTitle: 'Creación/registro de modificaciones del inmueble vendido en curso',
      dialogConfirmBVCreationTitle: 'Confirma la creación de tu propiedad vendida',
      cancelCreationBienVenduTitle: 'Cancelar la entrada de su propiedad vendida',
      modificacionSuccess: 'Su modificación se guardó exitosamente',
      CreationSuccess: 'Tu creación se ha guardado exitosamente',
      CreationFailed: 'Tu creación falló',
      dialogConfirmBVChangeTitle: 'Creación/registro de modificaciones del activo vendido actual',
      cancelCreationBienVenduText: '¿Estás seguro que quieres dejar la incautación de tu propiedad vendida? Entonces se perderá toda la información introducida en las diferentes pestañas.',
      formCreation: {
        initialPrice: 'Precio inicial *',
        livingSpace: 'Espacio vital',
        roomsNumber: 'Número de piezas',
        energyConsumption: 'Consumo de energía',
        streetNumber: 'Numero de canal',
        streetType: 'Tipo de canal',
        streetName: 'Nombre del Canal',
        postalCode: 'Código postal *',
        city: 'Ciudad *',
        salesAgreementDate: 'Fecha de compromiso',
        buyerOrigin: 'Origen del comprador',
        chooseOrigin: 'Elige un origen',
        saveAndClose: 'Guardar y cerrar',
        saveAndManagePosts: 'Guardar y personalizar publicaciones',
        saveAndManageDiffusion: 'Grabar y administrar transmisiones',
        buyerFees: 'Honorarios del comprador',
        sellerFees: 'Honorarios del comprador'
      }
    },
    report: {
      sendByEmail: 'Enviar por correo',
      print: 'Imprimir',
      goBackToAdList: 'Regresar a la lista de anuncios',
      dialogTitle: 'Transferir este anuncio por correo',
      dialogEmail: 'Correo del destinatario',
      dialogMessage: 'Su mensaje',
      dialogMessagePlaceholder: 'Su informe de presencia en archivo adjunto',
      dialogCancel: 'Cancelar',
      dialogSend: 'Enviar',
      city: 'Ciudad',
      price: 'Precio',
      yourAdHasBeDiffusedTo: 'Su anuncio ha sido enviado a ',
      yourAdIsOnlineOn: 'Su anuncio está en linea en',
      portals: 'portales',
      reportDate: 'Su informe de presencia a la fecha del',
      definition: 'Definición de los terminos utilizados',
      online: 'En línea',
      onlineText: 'Ubiflow verifica que su anuncio esté correctamente publicado en el portal.',
      diffused: 'Difundido',
      sent: 'Enviado',
      diffusedText: 'Su anuncio ha sido enviado al portal. Pero el portal no envía ninguna prueba de publicación a Ubiflow.',
      pdfName: 'Mi_Informe',
      emailSubject: 'Su informe para el anuncio {{ title }}',
      emailAttachmentFirstPart: 'Informe-',
      globalTitle: 'Estadísticas generales',
      lastIntegration: 'Fecha de última integración',
      adsIntegrated: 'Número de anuncios integrados',
      adsDeleted: 'Número de anuncios borrados',
      exportResults: 'Exportar los resultados',
      columnAd: 'Anuncio',
      columnDateCreation: 'Fecha de creación',
      columnDateModification: 'Fecha de modificación',
      columnPictures: 'Nb. fotos',
      filenameExportIntegration: 'export_informe_integración',
      filterRejected: 'Anuncios rechazados',
      filterWarn: 'Advertencia',
      numberCountERROR: 'Número de mensajes de error',
      numberCountWARN: 'Número de mensajes de advertencia'
    },
    privateNote: {
      postReference: 'Referencia',
      postPrice: 'Precio',
      postLocation: 'Ubicación',
      postSurface: 'Superficie',
      PostNumberRoom: 'Número de habitaciones',
      generalInformationTitle: 'Información general',
      postPrivateNote: 'Nota privada del anuncio',
      postBrand: 'Marca',
      postModel: 'Modelo',
      postEnergie: 'Energia',
      contenueNote: 'Contenido de la nota',
      messageSucces: 'Su nota ha sido actualizada'
    },
    linkedIn: {
      asideTitle: 'Información para publicar en LinkedIn',
      asideText: 'Edita desde esta pestaña el contenido a difundir en tu publicación de LinkedIn.<br><br>' +
        'Te ofrecemos contenido a difundir que puedes modificar integrando emojis y cambiando elementos de texto. También puede volver a él haciendo clic en el botón "Regenerar".<br><br>' +
        'También puede transmitir varias imágenes integradas desde la pestaña "Medios"<br><br>' + '' +
        'ATENCIÓN<br><br>' +
        'A Una vez que su publicación haya sido transmitida, su contenido ya no podrá editarse ni eliminarse desde su Área de Cliente de Ubiflow.\n',
      notActivated: 'La distribución de tus anuncios en LinkedIn no está activada. Para ello, contáctenos al 02 99 83 05 36.',
      generate: 'Regenerador'
    },
    descriptionTitle: 'Descripción',
    offerDescription: 'Descripción de la oferta',
    vehicleDescription: 'Descripción del vehículo',
    offerType: 'Tipo de oferta',
    propertyType: 'Tipo de propiedad',
    priceWithoutTaxes: 'Precio (sin gastos conexos)',
    ancillaryCosts: 'gastos conexos',
    defiscTitle: 'Ventajas de la inversión (defisc...)',
    offerTitle: 'Oferta',
    offerDetail: 'Detalle de la oferta',
    certificationsAndLabelsTitle: 'Certificaciones y sellos',
    energyTitle: 'Energia, calefacción',
    heatTitle: 'Calefacción',
    exteriorTitle: 'Exterior',
    interiorTitle: 'Interior',
    propertyDescriptionTitle: 'Descripción de la propriedad',
    environmentTitle: 'Entorno',
    idSite: 'Id página',
    urlAnnonceSiteAnnonceur: 'Url de su página',
    informationsComplementaires: 'Información adicional',
    titreMetaWeb: 'Metadata "title" de la página',
    descriptionMetaWeb: 'Metadata "description" de la página',
    pushMenu: 'Push menú',
    coupDeCoeur: 'Favorito',
    addVisiteVirtuelle: 'Agregar una visita virtual',
    propertyConditionTitle: 'Estado de la propiedad',
    coPropertyInformationTitle: 'Información de la copropriedad',
    propertyPartnerTitle: 'Socio propietario',
    dpeTitle: 'CEE',
    securityDeposit: 'Depósito de seguridad',
    myAd: 'Mi anuncio',
    saleConditionsTitle: 'Condiciones de venta',
    complementaryInformationTitle: 'Información adicional',
    equipments: 'Equipos',
    comfortEquipmentsTitle: 'Equipos de confort',
    securityEquipmentsTitle: 'Equipos de seguridad',
    otherEquipmentsTitle: 'Otros equipos ',
    generalInformationTitle: 'Información general',
    houseTitle: 'Casa',
    landTitle: 'Terreno',
    buildingLandTitle: 'Terreno para construcción',
    locationTitle: 'Ubicación',
    servicesTitle: 'Prestación',
    labelsAndCertificationsTitle: 'Sellos y certificaciones',
    equipementPresent: 'Equipamientos presentes',
    programs: 'Programa',
    loyer_an_m2: 'Alquiler sin IVA y sin gastos comunitarios por m2/año',
    instagramTitle: 'Información a difundir en Instagram',
    immoAncien: 'Bienes inmuebles antiguos',
    networks: {
      resetCaption: 'reiniciar',
      commercialText1: 'Mostrando sus publicaciones de anuncios en ',
      commercialText1Bis: 'no está activado.',
      commercialText2: '¿Sabías que también puedes suscribirte, además de esta distribución, a la generación de tus posts gracias a nuestra Inteligencia Artificial?',
      commercialText3: 'Transmitido en',
      commercialText3Bis: '¿está interesado en la edición automática de publicaciones con IA?',
      videoTitre: 'Video',
      videoTexte: 'Puede proporcionar una URL de video para ilustrar su publicación publicitaria en lugar de las fotos asociadas con su anuncio. Asegúrese de que sea una URL de vídeo y no la de un reproductor como Youtube o Dailymotion que no serían tomados en cuenta por las redes sociales.',
      videoUrlError: 'La URL del vídeo no es válida',
      videoButtonClap: 'Copiar URL del video de flujo',
      videoButtonGotoClap: 'También puedes generar un vídeo con <strong>Video Flow</strong>',
      videoEditoTitre: '<strong>O el enlace de tu video</strong> <span style="font-size: 0.8em">(solo para Facebook, Instagram y LinkedIn)</span>',
      videoEditoHelp: 'El enlace que inserte aquí debe ser un enlace de archivo alojado por usted. No ingrese a YouTube, Vimeo u otras URL que sean enlaces de reproducción. Estos no serán aceptados por las redes sociales.',
      instagram: {
        asideTitle: 'POST INSTAGRAM',
        asideText: 'Para ahorrarte tiempo, Ubiflow puede crear contenido personalizado utilizando Inteligencia Artificial, basándose en los datos de tu anuncio. Esta funcionalidad está disponible con nuestra oferta dedicada',
        asideInfoTitle: 'INFORMACIÓN INSTAGRAM',
        asideInfoText1: '1- Tu post incluye tus 10 primeras fotos',
        titleTextarea: 'GESTIONAR TU POST EN INSTAGRAM',
        textInfoTextarea: 'Puede seleccionar varias sugerencias antes de validar y hacer su elección. También tiene la posibilidad de modificar el contenido, añadir emojis o enriquecerlo con hashtags relevantes. Si lo necesita, puede volver a la propuesta original en cualquier momento haciendo clic en el botón "Restablecer".',
        textInfoIA: 'En el caso de los anuncios generados mediante nuestra Inteligencia Artificial, la modificación de uno o varios criterios de tu anuncio conllevará una actualización total o parcial del anuncio generado inicialmente, siempre y cuando el anuncio no sea difundido',
        titleWarning: 'ATENCIÓN',
        textWarning: 'Una vez publicado tu post, su contenido ya no podrá ser modificado ni eliminado desde tu Área de Cliente Ubiflow',
        infoNumberCharacters: 'Número de caracteres permitidos:',
        popupNumberCharacters: 'Ha superado el número máximo de caracteres.'
      },
      facebook: {
        asideTitle: 'POST FACEBOOK',
        asideText: 'Para ahorrarte tiempo, Ubiflow puede crear contenido personalizado utilizando Inteligencia Artificial, basándose en los datos de tu anuncio. Esta funcionalidad está disponible con nuestra oferta dedicada',
        asideInfoTitle: 'INFORMACIÓN FACEBOOK',
        asideInfoText1: '1- Tu publicación incluye tus 10 primeras fotos',
        titleTextarea: 'GESTIONAR TU POST EN FACEBOOK',
        textInfoTextarea1: 'Puede seleccionar varias sugerencias antes de validarlas y hacer su elección. También tiene la posibilidad de modificar el contenido, añadir emojis o enriquecerlo con hashtags relevantes.',
        textInfoTextarea2: 'Si lo necesita, puede volver a la propuesta original en cualquier momento haciendo clic en el botón "Restablecer".',
        textInfoIA: 'En el caso de los anuncios generados mediante nuestra Inteligencia Artificial, la modificación de uno o varios criterios de tu anuncio conllevará una actualización total o parcial del anuncio generado inicialmente, siempre y cuando el anuncio no sea difundido',
        titleWarning: 'ATENCIÓN',
        textWarning: 'Una vez publicado tu post, su contenido ya no podrá ser modificado ni eliminado desde tu Área de Cliente Ubiflow.'
      },
      google: {
        asideTitle: 'PUBLICAR PERFIL DE NEGOCIO DE GOOGLE',
        asideText: 'Para ahorrarte tiempo, Ubiflow te permite crear contenido personalizado mediante Inteligencia Artificial, basándose en los datos de tu anuncio. Esta funcionalidad está disponible con nuestra oferta dedicada',
        titleTextarea: 'GESTIONE SU ANUNCIO EN GOOGLE BUSINESS PROFILE',
        asideInfoTitle: 'INFORMACIÓN DEL PERFIL DE NEGOCIO DE GOOGLE',
        asideInfoText1: '1- Tu post incluye 1 foto',
        textInfoTextarea1: 'Puede seleccionar varias sugerencias antes de validarlas y hacer su elección. También tiene la posibilidad de modificar el contenido, añadir emojis o enriquecerlo con hashtags relevantes.',
        textInfoTextarea2: 'Si lo necesita, puede volver a la propuesta original en cualquier momento haciendo clic en el botón "Restablecer".',
        textInfoIA: 'Para los anuncios generados mediante nuestra Inteligencia Artificial, la modificación de uno o varios criterios de tu anuncio conllevará una actualización total o parcial del anuncio generado inicialmente, siempre y cuando el anuncio no haya sido publicado.',
        titleWarning: 'ATENCIÓN',
        textWarning: 'Una vez publicado tu post, su contenido ya no podrá ser modificado ni eliminado desde tu Área de Cliente Ubiflow.'
      },
      linkedin: {
        asideTitle: 'POST EN LINKEDIN',
        asideText: 'Para ahorrarte tiempo, Ubiflow puede crear contenido personalizado utilizando Inteligencia Artificial, basándose en los datos de tu anuncio. Esta funcionalidad está disponible con nuestra oferta dedicada',
        asideInfoTitle: 'INFORMACIÓN LINKEDIN',
        asideInfoText1: '1- La difusión de tu anuncio incluye tus 10 primeras fotos',
        titleTextarea: 'GESTIONAR TU POST EN LINKEDIN',
        textInfoTextarea1: 'Puede seleccionar varias sugerencias antes de validarlas y hacer su elección. También tiene la posibilidad de modificar el contenido, añadir emojis o enriquecerlo con hashtags relevantes.',
        textInfoTextarea2: 'Si lo necesita, puede volver a la propuesta original en cualquier momento haciendo clic en el botón "Restablecer".',
        textInfoIA: 'En el caso de los anuncios generados mediante nuestra Inteligencia Artificial, la modificación de uno o varios criterios de tu anuncio conllevará una actualización total o parcial del anuncio generado inicialmente, siempre y cuando el anuncio no sea difundido',
        titleWarning: 'ATENCIÓN',
        textWarning: 'Una vez publicado tu post, su contenido ya no podrá ser modificado ni eliminado desde tu Área de Cliente Ubiflow.'
      }
    },
    IA: {
      textSpinnerIA: 'Nuestra inteligencia artificial está inventando una gran publicación para ti. no pasará mucho tiempo...'
    },

    newPrograms: 'Nuevos programas',
    postType: 'Tipo de anuncios',
    facebook: {
      asideTitle: 'Información a publicar en su página de Facebook',
      asideText: 'Edite desde esta pestaña su publicación como desea que aparezca en su página de Facebook. ' +
                '<br><br> Ubiflow le ofrece una publicación generada automáticamente en función de los datos de su anuncio.' +
                '<br> Puede modificarlo antes de que se publique.',
      notActivated: 'Mostrar sus anuncios como publicaciones de Facebook no está habilitado. Para eso, contáctenos al 02 99 83 05 36.',
      alreadyBroadcasted: 'Su anuncio ya se ha difundido en su página de Facebook. Su contenido ya no se puede modificar.',
      generate: 'Regenerar'
    },
    clap: {
      toKnowTitle: 'A saber',
      toKnowText: 'Al hacer clic en "Generar mi aplauso", la distribución de tu publicación en las redes sociales es automática. Su claqueta se le entrega en forma de URL que puede usar como desee en otros medios.',
      attentionTitle: 'Atención',
      attentionText: 'Asegúrese de que su anuncio contenga al menos 5 imágenes para asegurarse de que su video se reproduzca bien.',
      disabledText: 'El producto de generación de video no está activada. Para ello, contáctenos al 02 99 83 05 36.',
      informationTitle: 'Información sobre tus vídeos',
      forfaitClapTitle: 'Tarifa mensual',
      forfaitClap: '{{ quotaMax }} video',
      monitoringClapTitle: 'Número de videos consumidos',
      monitoringClapTooltip: 'La cantidad de videos acumulados corresponde a tu plan mensual + los videos no utilizados en meses anteriores',
      monitoringClap: '{{ nbClapGeneres }}/{{ nbClapRestants }} acumulativo',
      generateClapButton: 'Generar mi vídeo',
      checkUrlClapButton: 'Actualizar para obtener el enlace de mi video',
      downloadClapButton: 'Descargar video',
      patientTextBegin: 'Tu video se está creando.<br>Espera unos minutos antes de hacer clic en el botón.',
      patientTextEnd: 'Si no quieres esperar, también puedes seguir navegando en tu area de clientes de Ubiflow y volver en unos minutos.',
      msgClapInProgress: 'Generación de aplausos en progreso',
      msgClapEnded: '¡Generación de aplausos completa!',
      msgClapLaunch: 'Lanzamiento de la generación vídeo'
    },
    imageDescription: 'Archivo JPG/PNG con un tamaño inferior a 3MB',
    newPost: 'Crear una publicación',
    // Textos para DialogDeletePlanifBrouillon
    deletePlanifBrouillons: {
      title: 'Publicar ahora',
      message: 'Está a punto de eliminar la programación actual. ¿Está seguro de que desea continuar?',
      confirm: 'Sí, confirmo',
      cancel: 'Cancelar'
    },
    // Textos para DialogPublishNow
    publishNow: {
      title: 'Publicar ahora',
      message: '¿Está seguro de querer publicar ahora su publicación en las redes sociales seleccionadas?',
      confirm: 'Sí, quiero publicar ahora',
      cancel: 'Volver al paso anterior'
    },
    // Textos para PostEditoCreateModalConfirmStopCustom
    stopCustom: {
      title: 'Cancelar la personalización de la publicación',
      message: 'Si confirma, se perderá la personalización de su publicación para esta red social. ¿Está seguro de querer continuar?'
    },
    // Textos para PostEditoCreateModalIA
    ia: {
      prompt: 'Especifique el tema de la publicación en pocas palabras: "Jornada de puertas abiertas", "Contratación", ...',
      context: 'Cuanto más preciso sea al aportar elementos de contexto, más se redactará su mensaje con un alto nivel de calidad y personalización.',
      limitation: 'Nota: Solo es posible una generación con nuestra IA por medio y por publicación.',
      cancel: 'Cancelar',
      generate: 'Generar mi publicación'
    },
    // Textos para DialogPlanifPostEditorial
    planification: {
      title: 'Programar sus publicaciones',
      instruction: 'Elija cuándo publicar su contenido en cada una de las redes sociales seleccionadas.',
      publishNow: 'O publicar ahora',
      alreadyPublishedFacebook: 'Su publicación ya ha sido difundida en Facebook',
      alreadyPublishedInstagram: 'Su publicación ya ha sido difundida en Instagram',
      alreadyPublishedGoogle: 'Su publicación ya ha sido difundida en Google',
      alreadyPublishedLinkedin: 'Su publicación ya ha sido difundida en LinkedIn',
      selectDateTime: 'Seleccione fecha y hora',
      apply: 'Aplicar mis opciones de publicación'
    }
  },
  portals: {
    broadcast: {
      quotaProgram: 'Programas',
      quotaLot: 'Lotes',
      noAdSelected: 'Ningun anuncio seleccionado',
      selectedAds: 'anuncio seleccionado',
      selectedAds_plural: 'anuncios seleccionados',
      disableDiffusion: 'Desactivar la difusión',
      diffuseAds: 'Difundir esos anuncios',
      quota: 'Cuota',
      quotaUnlimited: 'Ilimitado',
      lastDiffusion: 'Última difusión',
      lastDiffusionUnknown: 'Desconocida',
      selectedAdsPortal: 'Anuncio(s) seleccionado(s)',
      tooltipSelectedAdsPortals: 'Total de anuncios seleccionados publicados y no publicados.',
      remainingMessageQuota: 'Cuidado, solo le queda {{ number }} anuncios antes de llegar a su cuota',
      reachedAdsLimitQuotas: 'Tenga en cuenta que ha alcanzado su cuota y ya no puede seleccionar anuncios.',
      overMessageQuota: 'Tenga en cuenta que ha seleccionado más anuncios que la cuota autorizada.',
      adsSelection: 'Selección de los anuncios',
      adsSelectionText: 'Seleccione los anuncios que desea difundir en el portal',
      backProgram: 'Regresar al programa',
      columnSent: 'Difundido',
      columnSelected: 'Seleccionado',
      columnPicture: 'Foto',
      columnReference: 'Réferencia',
      columnCity: 'Ciudad',
      columnPrice: 'Precio',
      columnActions: 'Acciones',
      priceContactUs: 'Consultarnos',
      confirmSelectionDeactivation: '¿Está seguro de que desea desactivar su selección de anuncios?',
      confirmSelectionDeactivationTitle: 'Desactivar transmisión',
      deactivated: 'Desactivar',
      confirmSelectionDiffusion: '¿Está seguro de que desea mostrar los anuncios seleccionados?',
      confirmSelectionDiffusionTitle: 'Mostrar estos anuncios',
      broadcast: 'Transmisión',
      messageSuccessDeactivation: 'Su solicitud de desactivación ha sido tenida en cuenta.',
      messageSuccessDiffusion: 'Se ha tenido en cuenta su solicitud para emitir anuncios.'
    },
    list: {
      diffuseMyAds: 'Difundir mis anuncios',
      showAllPortals: 'Mostrar todos los portales',
      activationToPaidPortalTitle: 'Activación de la diffusion hasta {{ portal }}',
      activationToPaidPortalText: 'Esta suscripción es de pago.' +
                '<br/><br/>Por favor de contactar el portal para registrarse, indicando que ' +
                'usted es también un cliente Ubiflow para la difusión de sus anuncios.' +
                '<br/><br/>Una vez su suscripción validada, Ubiflow recibirá la información técnica y ' +
                'configurará la difusión hasta este portal.' +
                '<br/><br/>Aquí el contacto comercial del portal : {{ email }}<br/>',
      activationResultTitle: 'Resultado de la activación de la difusión',
      activateUbiflowPackageTitle: 'Activar el paquete Ubiflow',
      activateUbiflowPackageText: 'Está a punto de activar la difusión de sus anuncios hasta la totalidad ' +
                'del paquete visibilidad de Ubiflow, desea continuar con está activación ?',
      deactivateDiffusionTitle: 'Desactivación de la difusión',
      deactivateDiffusionText: '¿ Está seguro de querer desactivar la difusión hasta este portal ?',
      deactivateDiffusionConfirmation: 'La difusión ha sido desactivada.',
      pushToTopOfListTitle: 'Subida de los anuncios al principio de la lista.',
      activationResultUbiflowPackageTitle: 'Resultados de la activación del paquete',
      activationResultUbiflowPackageAdded: 'Aquí las difusiones agregadas a su lista de portales',
      activationResultUbiflowPackageRemoved: 'Las diffusiones hasta los portales siguientes han sido recientemente desactivados de nuestro portal',
      activationResultUbiflowPackageMessage: 'El paquete Ubiflow evoluciona y agrega nuevos portales de forma continua. ' +
                'Para cada notifiación de portal agregado, haga clic de nuevo en el botón ' +
                '´Activar el paquete Ubiflow´ y difunda más ampliamente.',
      impossibleToActiveModalTitle: 'Activación de la diffusión al portal : ',
      impossibleToActiveModalText: 'Gracias por contactar directamente el portal para configurar la difusión.\n' +
                'Los datos de contacto del equipo comercial del portal son :',
      mail: 'Correo',
      tel: 'Tel',
      confirm: 'Confirmar',
      cancel: 'Cancelar',
      close: 'Cerrar',
      result: 'Resultado',
      pushToTopOfList: 'Subir al principio de la lista',
      exportResults: 'Exportar los resultados',
      export: 'Exportar',
      forSelection: 'Para la selección',
      results: 'Resultados',
      columnActivate: 'Activada',
      columnLogo: 'Logo',
      columnPortal: 'Portal',
      columnAds: 'Anuncios',
      columnLastDiffusion: 'Último envío',
      columnSelectAds: 'Seleccionar mis anuncios',
      columnActions: 'Acciones',
      columnDiffused: 'Difundida',
      columnPicture: 'Foto',
      columnReference: 'Referencia',
      columnCity: 'City',
      columnPrice: 'Precio',
      columnEditDiffusion: 'Gestionar mi difusión',
      columnMyPortal: 'Mi portal',
      columnCategory: 'Categoria',
      columnSelectionType: 'Tipo de selección',
      columnContacts: 'Contactos',
      columnProspects: 'Prospectos',
      columnPublication: 'Enviado',
      actionReport: 'Informe de difusión',
      actionSuspend: 'suspender la difusión',
      actionActivate: 'Activer la difusión',
      buttonAds: 'Anuncios',
      buttonActivate: 'Activar',
      goBackToDiffusionList: 'Regresar a la lista de difusiones',
      deactivateDiffusion: 'Desactivar la difusión',
      activateDiffusion: 'Activar la difusión',
      portalSelection: 'Selección de los portales en los cuáles difundir el anuncio',
      portalSelectionActivateDiffusionTitle: 'Activar la difusión para esta selección de portales',
      portalSelectionActivateDiffusionText: '¿ Confirmar la selección ?',
      portalSelectionDeactivateDiffusionTitle: 'Desactivar la difusión para esta selección de portales',
      portalSelectionDeactivateDiffusionText: '¿ Desactivar la selección ?',
      portalSelectionDeactivationConfirmationTitle: 'Desactivación de la difusión',
      portalSelectionDeactivationConfirmationText: 'La difusión de su anuncio ha sido desactivada.',
      dateLastDiffusion: 'Fecha de la última difusión',
      noDiffused: 'No difundida',
      numberOfSelectedPortals: 'Número de portales seleccionados',
      numberOfSelectedPrograms: 'Número de programas seleccionados',
      filenameExportDiffusions: 'difusiones',
      filenameExportAdsSelection: 'seleccion_anuncios',
      filenameExportPortals: 'lista_portales',
      dialogPushToTopOfListTitle: 'Subir los anuncios al principio de la lista',
      dialogPushToTopOfListTextSuccess: 'Sus anuncios serán publicados en los primeros lugares en los portales ' +
                'seleccionados y que lo permiten a la siguiente difusión.',
      dialogPushToTopOfListTextLimit: 'Solo puede usar esa funcionalidad una vez a la semana. Gracias.',
      dialogPushToTopOfListButtonConfirm: 'Confirmar',
      dialogPushToTopOfListButtonClose: 'Cerrar',
      dialogEditPostQuota: 'Modificación del estatus de difusión hasta',
      dialogEditIdentifiants: 'Cambio de ID editables',
      champObligatoire: 'Campo obligatorio',
      aucunIdentifiantEditable: 'No hay ID editable para este portal',
      doNotBroadcast: 'No difundir',
      unlimited: 'Ilimitado',
      limitedToXPosts: 'Límite de anuncios',
      contactBroadcasterToEditQuota: 'Para modificar el estatus de difusión hasta este portal, por favor de contactacrlo directamente.',
      limitedTo: 'Limitado a',
      editQuota: 'Modificar cuota',
      editIdentifiants: 'Modificar / Introducir identificadores',
      immowebUrlConnexion: 'Conexión espacial Immoweb',
      selogerUrlConnexion: 'Permitir que Ubiflow transmita en los sitios del grupo Seloger',
      selectedAds: 'Anuncios seleccionados',
      quotaPerso: 'Cuota personal',
      statutDIff: 'Estado de difusión',
      chargementDonnees: 'Estamos cargando tus datos, un poco más de paciencia;)',
      validateLotsDiffusionBailleur: 'Está a punto de emitir anuncios y/o programas. Al marcar esta casilla, confirma que también se emiten todos los lotes asociados con los programas seleccionados. Si no lo desea, desmarque los programas en cuestión y luego seleccione manualmente los lotes para transmitir desde la página "Ver lotes".',
      nbLotsBroadcasted: 'Número de lotes difundidos',
      validateLotsDiffusion: 'Está a punto de difundir un nuevo programa. ¿Le gustaría que también se difundieran todos los lotes asociados?',
      noDiffusionTitle: 'Difusión',
      noDiffusionText1: 'Esta funcionalidad no está activada en su subscripción',
      noDiffusionText2: '¿POR QUÉ ACTIVAR EL PRODUCTO DE DIFUSIÓN DE UBIFLOW?',
      noDiffusionText3: 'Difundir con Ubiflow, es tener la posibilidad de <strong>personalizar, enriquecer, medir y' +
                'enviar</strong> sus anuncios en los medios web con aún más relevancia. <br><br>' +
                'Si administra sus anuncios desde una herramienta de terceros (software, página, CRM), o si ' +
                'los administra con nuestro Espacio Cliente, asegure la difusión de sus anuncios con total autonomía.',
      noDiffusionText4: 'AHORRO DE TIEMPO',
      noDiffusionText5: 'Envíe sus anuncios a todas partes en los distintos portales en <strong>1 clic.</strong> Desde 1 unico ' +
                'lugar, su Espacio Cliente ! Puede olvidarse de sus varias cuentas en las que necesita iniciar sesión y de la dificultad ' +
                'de utilizar cada una de las herramientas disponibles. <strong>¡Un importante ahorro de tiempo!</strong>',
      noDiffusionText6: 'PERSONALIZACIÓN DE SU DIFUSIÓN',
      noDiffusionText7: '¡Gestione la difusión de sus anuncios de forma agrupada o personalizada! <br> ' +
                'Una excelente práctica para apuntar a la <strong>audiencia correcta</strong>, en el medio adecuado en el momento adecuado ' +
                'en función de su inventario de anuncios.',
      noDiffusionText8: 'SEGUIMIENTO DE SU PRESENCIA EN LOS PORTALES',
      noDiffusionText9: '<strong>Siga la difusión de sus anuncios</strong> gracias a nuestros informes de distribución y presencia puestos a ' +
                'su disposición. Identificamos rápidamente los puntos de bloqueo y los motivos' +
                'para intervenir lo antes posible.. ¡No se preocupe por nada! Nuestro equipo contacta con los portales necesarios.',
      noDiffusionText10: 'CALCULE SU ROI Y GESTIONE SU PRESUPUESTO',
      noDiffusionText11: 'Nuestra herramienta de difusión junto con nuestra solución de gestión de contactos',
      noDiffusionText12: 'le permite identificar los portales en los que sus anuncios son <strong>más ' +
                'visitados</strong> y que <strong>generan más contacto. ¡Optimice sus costos de difusión!</strong>',
      noDiffusionText13: '24 opciones enriquecen nuestro producto de difusión, la mayoría de las cuales se incluyen por defecto: ' +
                'difusión selectiva, personalización de los datos de contacto indicados en sus anuncios, Subida de los anuncios ' +
                'al principio, herramienta de edición, transmisor múltiple, …',
      reconciliationRequests: 'Solicitudes de conciliación',
      TextReconciliation: 'Son solicitudes realizadas por usuarios de Internet en un portal pero que no se refieren a un anuncio en particular. Se le envía una notificación por correo electrónico en paralelo para los sitios que lo permiten. Estos contactos no se cuentan en el número de contactos generados en total.',
      selogerMessaqeAuthorisationOk: '<div>Usted ha autorizado a Ubiflow a transmitir en los sitios del grupo Seloger.</div>\n<div>Nuestra relación con el cliente ha sido notificada, gracias.</div>',
      selogerMessaqeAuthorisationKo: 'Error de carga en esta página'
    },
    report: {
      globalTitle: 'Estadísticas generales',
      title: 'Estadísticas de difusión hasta el portal',
      quota: 'Cuota',
      quotaAds: 'anuncios',
      quotaUnlimited: 'Ilimitado',
      selectedAds: 'anuncios seleccionados',
      selectionMode: 'Modo de selección de los anuncios',
      lastDiffusion: 'Último envío',
      adsDiffused: 'anuncios difundidos',
      filter: "'Filtrar los anuncios por referencia...",
      selected: 'Seleccionados',
      diffused: 'Difundidos',
      published: 'Publicados',
      exportResults: 'Exportar los resultados',
      exportResultsWithoutContact: 'Exportar anuncios sin contacto',
      columnStatus: 'Estatus',
      columnAd: 'Anuncio',
      columnReference: 'Réferencia',
      columnDateCreation: 'Fecha de creacción',
      columnDateModification: 'Fecha de modificación',
      columnPictures: 'Nb. fotos',
      columnDateDiffused: 'Fecha de difusión',
      columnLogo: 'Logo',
      columnPortal: 'Portal',
      columnDateDiffusion: 'Fecha de difusión',
      columnAdsDiffused: 'Anuncios difundidos',
      statusError: 'Error',
      statusPublished: 'Publicado',
      statusDiffused: 'Difundido',
      statusIgnored: 'Ignorado',
      convertDateBeginning: 'El {{ date }}',
      lastUpdateAds: 'Última modificación de los anuncios',
      activePortals: 'Portales activos',
      globalAdsDiffused: 'Anuncios difundidos',
      detailedReportsPortalByPortal: 'Los informes detallados, portal por portal',
      noMessage: 'Sin mensaje',
      filenameExportDiffusion: 'export_informe_difusion'
    }
  },
  users: {
    edit: 'Editar',
    addUser: 'Agregar un usuario',
    role: 'Rol',
    rolePlaceholder: 'Seleccionar un rol...',
    lastname: 'Apellido',
    firstname: 'Nombre',
    email: 'Correo',
    phone: 'Teléfono',
    mobile: 'Mobile',
    address: 'Dirección',
    postalCode: 'Código postal',
    city: 'Ciudad',
    country: 'País',
    price: 'Precios del usuario',
    placeholderPrice: 'Indicar el enlace hasta los precios de la agencio',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    createNewUser: 'Crear un nuevo usuario',
    editUser: 'Editar usuario',
    messageCreate: 'El usuario ha sido creado exitosamente',
    messageCreateAccess: 'Su solicitud ha sido recibida. ' +
            'Nuestro equipo se pondrá en contacto con usted a la mayor brevedad para definir conjuntamente las diferentes modalidades de acceso.',
    messageUpdate: 'El usuario ha sido actualizado exitosamente',
    messageDelete: 'El usuario acaba de ser eliminado.',
    messageError: 'Un error occurrió',
    forSelection: 'Para la selección',
    export: 'Exportar',
    exportAll: 'Exportar todo',
    listMode: 'Modo de lista',
    vignetteMode: 'Modo cuadrícula',
    enabled: 'Activado',
    disabled: 'Desactivado',
    actionsOnThisUser: 'Acciones sobre este usuario',
    logIn: 'Conectarse',
    allUsers: 'Todos los usuarios',
    activeUsers: 'Usuarios activos',
    inactiveUsers: 'Usuarios intactivos',
    confirmationMessage: 'Será redireccionado hacia el Espacio Cliente de un colaborador vinculado a su cuenta.',
    caution: 'Attención',
    mailSended: 'Las instrucciones de creación de cuenta han sido enviadas al usuario por correo.',
    createAccess: '¿Quiere crear un acceso al Espacio Cliente a este nuevo contacto?',
    mainAccount: 'cuenta principal',
    contact: 'Contacto',
    admin: 'Administrador',
    user: 'Usuario'
  },
  profile: {
    save: 'Guardar',
    cancel: 'Cancelar',
    myPersonalInformation: 'Mi información personal',
    lastname: 'Apellido',
    firstname: 'Nombre',
    email: 'Correo',
    phone: 'Teléfono',
    agencyInformation: 'Información de la agencia',
    corporateName: 'Razón social',
    companyName: 'Nombre de la empresa',
    address: 'Dirección',
    postalCode: 'Código postal',
    city: 'Ciudad',
    country: 'País',
    fax: 'Fax',
    website: 'Página web',
    price: 'Precios del usuario',
    placeholderPrice: 'Indicar el enlace hasta los precios de la agencio',
    logo: 'Logo',
    uploadTip: 'Archivos jpg/jpeg/png con un tamaño inferior a 2Mo',
    activateAdsToTopFunctionality: 'Activar la gestión manual des remontées en tête de liste de vos annonces sur les portails compatibles.',
    messageSuccess: 'La configuración ha sido actualizada',
    messageSuccessAgency: 'La configuración de la agencia ha sido actualizada',
    messageError: 'Un error occurrió',
    saveFilters: 'Mantener mis filtros de búsqueda después de cerrar sesión',
    Configurations: 'Otras configuraciones',
    saveFiltersTitle: 'Configurar la búsqueda en mi Área de Clientes de Ubiflow',
    activateAdsToTopFunctionalityTitle: 'Configurar feeds de la parte superior de la lista',
    soldProductMaskColorTitle: 'Configurar el color de los banners vendidos'
  },
  exports: {
    description: 'Sus archivos estarán disponibles aquí durante dos semanas a partir de la fecha de exportación.',
    removeTitle: 'Borrar su archivo',
    removeText: '¿Está seguro de querer borrar su archivo?',
    removeSuccess: 'Su archivo ha sido borrado exitosamente.',
    multipleRemoveSuccess: 'Sus archivos han sido borrado exitosamente.'
  },
  general: {
    yes: 'Sí',
    no: 'No',
    month: 'mes',
    year: 'año',
    week: 'semana',
    exitConfirmation: '¿ Está seguro que quiere salir ?',
    ubiflowWebsite: 'Ubiflow.net',
    calendar: {
      socialManagment: 'Adopta una estrategia de redes sociales',
      planning: 'Gestión de la planificación',
      changeTheSchedule: 'Cambiar el horario',
      planningSubtitle: 'Adelántate planificando tus publicaciones con el calendario editorial: ',
      lastWeek: 'Última semana',
      lastMonth: 'Último mes',
      lastThreeMonths: '3 últimos meses',
      lastSixMonths: '6 últimos meses',
      lastTwelveMonths: '12 últimos meses',
      slogan1: 'Seleccionar días y horarios de publicación',
      slogan2: 'Integrar una estrategia efectiva de Redes Sociales',
      slogan3: 'Superar una tarea repetitiva',
      slogan4: 'Reduce tu tiempo planificando publicaciones',
      slogan5: 'Asegura una presencia regular en tus redes sociales',
      slogan6: 'Gestión de opiniones enviadas y respuestas automatizadas gracias a la IA\n',
      slogan7: 'Gestión de preguntas/respuestas publicadas en Google',
      slogan8: 'Acceso a datos estadísticos',
      planningDate: 'Fecha de publicación',
      spreadOn: 'Transmitir en',
      scheduled: 'Planificar',
      publishNow: 'Publicar ahora',
      edit: 'Editar',
      delete: 'Borrar',
      postNoPlanned: 'Publicación no planificada',
      postPublished: 'Publicación publicada',
      postPlanned: 'Publicación programada',
      postAlreadyPlanned: 'Publicación ya publicada',
      acceptedPost: 'Aceptar',
      refusedPost: 'Rechazar',
      planningPost: 'Planificación',
      publishingPost: 'Publicación',
      areYouSureYouWantToPublishYourPost: '¿Seguro que quieres publicar tu entrada?',
      areYouSureYouWantToPlanYourPost: '¿Seguro que quieres programar tu publicación?',
      thePostWasPlanned: 'La publicación estaba planeada.',
      thePostWasPublished: 'La publicación ha sido publicada.',
      ThePlanningWasUnsuccessful: 'La programación falló.',
      ThePublicationWasUnsuccessful: 'Publicación fallida.',
      TheCurrentScheduleHasBeenCanceled: 'El horario actual ha sido cancelado.',
      TheCurrentPublicationHasBeenCanceled: 'La publicación actual ha sido cancelada.',
      deletionHasBeenUndone: 'Se ha deshecho la eliminación.',
      deletionHasBeenCompleted: 'Se ha completado la eliminación.',
      areYouSureYouWantToDeleteYourSchedule: '¿Estás seguro de que quieres eliminar tu horario?',
      areYouSureYouWantToDeleteYoursScheduleSelected: '¿Está seguro de que desea eliminar los horarios seleccionados {{refsUniquesSelection}} ?',
      areYouSureYouWantToChangeYourSchedule: '¿Seguro que quieres cambiar tu horario?',
      warningSheduledBefore: 'Su programación no se puede ejecutar porque es anterior a la fecha de hoy.',
      deletionFailed: 'Eliminación fallida.',
      deletionPost: 'Publicación de eliminación',
      Amendment: 'Enmienda',
      theChangeHasBeenMade: 'El cambio se ha realizado.',
      theChangeHasBeenUndone: 'El cambio se ha deshecho.',
      deleteSchedule: 'borrar horario',
      mailSubjectSocialManagmentPlus: 'Nueva solicitud de información de la oferta Social Manager + desde el Área de Clientes',
      emailContentSocialManagmentPlus: 'Hola, Se ha realizado una nueva solicitud de información desde el Área de Clientes para el paquete Social Manager +' +
          ' por el anunciante {{advertiser}} ({{companyName}}) . Puedes contactarlo de nuevo ' +
          ' vía {{email}} o en {{phoneNumber}}' +
          ' Gracias. Que tenga un buen día.',
      emailSendSuccess: 'Tu correo electrónico fue enviado con éxito.',
      loaderMessageCalendar: 'Paciencia ! Tus datos se están cargando, puede que tarde unos segundos.',
      featureForbidden: 'Característica no disponible'
    },
    sort: {
      date: 'Fecha',
      decreaseDate: 'Fecha decreciente',
      increaseDate: 'Fecha creciente',
      reference: 'Referencia',
      title: 'Título',
      name: 'Nombre',
      lastDiffusion: 'Fecha del último envío',
      datePublication: 'Fecha de publicación',
      ads: 'Anuncios',
      contacts: 'Contactos',
      dateCreation: 'Fecha de creación',
      contactEmail: 'Contactos correo',
      contactTel: 'Contactos tel.',
      contactName: 'Nombre contacto',
      callDurationDecrease: 'Duración llamada decreciente',
      callDurationIncrease: 'Duración llamada creciente',
      callNumber: 'N° teléfono',
      portalName: 'Nombre portal'
    },
    selection: {
      forSelection: 'Para la selección',
      exportAll: 'Exportar todo',
      export: 'Exportar',
      activateDeactivate: 'Activar/Suspender',
      changeContact: 'Editar contacto',
      activeAds: 'Anuncios activos',
      inactiveAds: 'Anuncios inactivos',
      download: 'Descargar',
      remove: 'Borrar',
      validate: 'Validar'
    },
    filters: {
      allAds: 'Todos los anuncios',
      allPrograms: 'Todos los programas',
      allLots: 'Todos los lotes',
      activeAds: 'Anuncios activados',
      inactiveOrDraftAds: 'Anuncios desactivados o borradores',
      withoutPictures: 'anuncios sin fotos',
      diffusedAds: 'Anuncios difundidos',
      noDiffusedAds: 'Anuncios no difundidos',
      modelAds: 'Anuncios modelos',
      stockSelection: 'Selección del stock',
      stockSelectionPlaceholder: 'Seleccionar un stock',
      brand: 'Marca',
      brandPlaceholder: 'Seleccionar una marca',
      model: 'Modelo',
      models: 'Modelos',
      modelPlaceholder: 'Seleccionar un modelo',
      openSearch: 'Buscar por ciudad, título, referencia',
      openSearchPlaceholder: 'Buscar',
      offerType: 'Tipo de oferta',
      offerTypePlaceholder: 'Seleccionar un tipo',
      programType: 'Tipo de programa',
      programTypeLand: 'Terreno',
      programTypeLandHouse: 'Programa terreno + casa',
      propertyType: 'Tipo de propiedad',
      propertyTypeVo: 'Tipo de vehículo',
      mandateType: 'Tipo de mandato',
      mandateTypeAll: 'Todos',
      mandateTypeSimple: 'Simple',
      mandateTypeExclusive: 'Exclusivo',
      mandateTypeSemiExclusive: 'Semi-exclusivo',
      date: 'Buscar por fecha',
      dateCreation: 'Fecha de creacción',
      dateDiffusion: 'Fecha de difusión',
      datePublication: 'Fecha de publicación',
      dateCreationStart: 'Desde ...',
      dateCreationEnd: 'hasta...',
      surface: 'Superficie : entre {{ surfaceGt }}m² y {{ surfaceLt }}m²',
      vehicleYear: 'Año',
      priceMin: 'Precio min',
      priceMax: 'Precio max',
      tooltipContactList: 'Para que todos sus contactos aparezcan en la lista a continuación, asegúrese de haber ingresado su nombre y apellido en la libreta de contactos.',
      title: 'Buscar por título',
      titleReference: 'Buscar por título, referencia',
      titleReferenceCity: 'Búsqueda por título, referencia, ciudad',
      portalName: 'Buscar por nombre de portal',
      titlePlaceholder: 'Buscar...',
      portalCategory: 'Catégoria de portal',
      portalCategoryPlaceholder: 'Todas las categorias',
      businessModel: 'Modelo económico',
      businessModelFree: 'Gratuito',
      businessModelPaid: 'Pago',
      quota: 'Cuota de anuncios',
      quotaWith: 'Con cuota',
      quotaWithout: 'Sin cuota',
      allPortals: 'Todos los portales',
      activePortals: 'Portales activos',
      inactivePortals: 'Portales inactivos',
      onlySelectedPortals: 'Unicamente los portales seleccionados',
      onlyNoSelectedPortals: 'Unicamente los portales no seleccionados',
      adReference: 'Referencia del anuncio',
      adReferencePlaceholder: 'Búsqueda...',
      integratedAds: 'Anuncios integrados',
      warningAds: 'Advertencia',
      errorAds: 'Anuncios rechazados',
      noPictureAds: 'Anuncios sin fotos',
      adsWithContacts: 'Anuncios con contactos',
      adsWithoutContacts: 'Anuncios sin contacto',
      onlyActiveAds: 'Unicamente anuncios activos',
      freePortals: 'Portales gratuitos',
      paidPortals: 'Portales de pago',
      portalsWithoutContact: 'Portales sin contact',
      portalsWithContacts: 'Portales con contactos',
      allContacts: 'Todos los contactos',
      name: 'Buscar por nombre',
      referenceContactEmail: 'Buscar por referencia, contacto, o correo',
      portalContactEmail: 'Buscar por nombre de portal, contacto, o correo',
      phoneNumber: 'Buscar por número de teléfono',
      callStatus: 'Estatus de la llamada',
      callAnswered: 'Llamada contestada',
      callMissed: 'Llamada perdida',
      all: 'Todos',
      typeLandHouse: 'Programa de terreno + casa',
      resetFilters: 'Restablecer filtros',
      deletedPosts: 'Listados eliminados',
      socialNetworks: 'Redes sociales',
      soldPosts: 'Propiedades vendidas',
      marchandVo: 'Comerciante vo',
      marchandVoPlaceholder: 'Elija un concesionario de vehículos usados',
      energie: 'Energía',
      energiePlaceholder: 'Elige una energía',
      kilometrageMin: 'kilometraje mínimo',
      kilometrageMax: 'kilometraje máximo',
      achatvo: 'Compra',
      achatvoPlaceholder: '(Lote o individualmente)',
      achatLot: 'Lote',
      achatUnite: 'A la unidad',
      annoncesValides: 'Anuncios validados',
      annoncesNonValides: 'Anuncios no validados',
      negociateur: 'Buscar por agente',
      negociateurPlaceholder: 'Investigación...'
    }
  },
  planning: {
    calendar: 'Calendario',
    backToCalendar: 'Volver al calendario',
    title: 'Gestión de la planificación',
    day: 'Día',
    today: 'Hoy',
    week: 'Semana',
    month: 'Mes',
    jour4: '4 días',
    beContacted: '¿Interesado en este producto? Ser contactado por un asesor de ventas.',
    searchByTitle: 'Buscar por título, referencia',
    searchPlaceholder: 'Investigación',
    typePost: 'Tipo de contenido',
    choiceTypePost: 'Elige por tipo de contenido',
    all: 'Todos los mensajes',
    instagram: 'Instagram',
    facebook: 'Facebook',
    gmb: 'Google Business Profile',
    linkedin: 'Linkedin',
    dialogMessage: 'Quiere información sobre nuestro producto Social Manager +. Nuestro equipo se pondrá en contacto contigo lo antes posible.',
    postsAds: 'Puestos de anuncios',
    postsBv: 'Inmuebles vendidos',
    postsEdito: 'Posts de editoriales',
    searchByMonth: 'Búsqueda por mes',
    selectedMonth: 'Selecciona un mes',
    postsList: 'Lista de posts',
    forSelection: 'Para la selección ({{ selectedNumber }}):',
    resultsOfTheDate: 'Resultado(s) para la fecha de',
    titleAds: 'Título del anuncio',
    pictures: 'Fotos',
    publishOn: 'Publicado el',
    date: 'Fecha',
    status: 'Estado'
  },
  socialPosts: {
    list: {
      postAnnonces: 'Posts de anuncios',
      biensVendus: 'Posts de bienes vendidos',
      postsEditoriaux: 'Posts editoriales',
      publishOn: 'Publicado el',
      publishedOn: 'Publicado el',
      actions: 'Acciones',
      noSubscription: 'No se ha suscrito a la oferta "redes sociales y presencia local". <br>\n' +
          'Para obtener más información y ser contactado por un representante de ventas, haga clic en el botón de abajo.'
    },
    scheduledAt: 'Programado el',
    sentAt: 'Enviado el',
    models: {
      title: 'Mi biblioteca de plantillas de publicaciones',
      header: 'Para crear una nueva publicación a partir de una plantilla, puede seleccionar una plantilla de la lista a continuación haciendo clic en "Utilizar".\n' +
        '<br><br>' +
        'Desde el formulario de edición de la publicación, podrá modificar su contenido, texto y medios, así como gestionar la selección de medios.',
      saveModel: 'Guardar la plantilla',
      cantEdit: 'Esta plantilla proviene de su cabeza de red, no puede editarla',
      cantDelete: 'Esta plantilla proviene de su cabeza de red, no puede eliminarla'
    },
    create: {
      core: {
        missingRequiredFields: 'No ha completado los campos requeridos.',
        putOnDraft: 'Poner en borrador',
        missingNetworkSelection: 'No ha completado todos los campos obligatorios o no ha seleccionado ninguna red social para difusión.',
        publish: 'Publicar',
        cancel: 'Cancelar',
        modalDeletePlanifBrouillons: 'Está a punto de convertir esta publicación en borrador. Cuando desee publicar esta publicación en las redes sociales de su elección, deberá especificar una nueva fecha de planificación'
      },
      newPost: 'Nueva publicación',
      deletePlanifBrouillons: {
        message: 'Está a punto de convertir esta publicación en borrador. Cuando desee publicar esta publicación en las redes sociales de su elección, deberá especificar una nueva fecha de planificación.',
        confirm: 'Confirmo el cambio a borrador',
        cancel: 'Cancelar'
      },
      validator: {
        fieldsRequired: 'No ha completado los campos requeridos.',
        fieldsRequiredComplete: 'Debe completar todos los campos obligatorios: Título, contenido, medios y elegir al menos una red social.'
      },
      modalAI: {
        objectTitle: 'Especifique el propósito de la publicación en pocas palabras: "Jornada de puertas abiertas", "Recrutamiento", ...',
        objectSubtitle: 'Cuanto más preciso sea al traer elementos de contexto, más se redactará su mensaje con un alto nivel de calidad y personalización.\n' +
          '        <br>Nota: Solo es posible una generación a través de nuestra IA por medio y por publicación.',
        cancel: 'Cancelar',
        generatePost: 'Generar mi publicación'
      },
      confirmStop: {
        title: 'Cancelar la personalización del post',
        text: 'Si confirma, se perderá la personalización de su publicación para esta red social. ¿Está seguro de que desea continuar?'
      },
      publishNow: {
        title: 'Publicar ahora',
        text: '¿Está seguro de que desea publicar ahora su post en las redes sociales seleccionadas?',
        confirm: 'Sí, quiero publicar ahora',
        cancel: 'Volver al paso anterior'
      },
      confirmStopCustom: {
        title: 'Cancelar la personalización del post',
        text: 'Si confirma, se perderá la personalización de su publicación para esta red social. ¿Está seguro de que desea continuar?'
      },
      initial: {
        title: 'Publicación inicial',
        subtitle: 'Este contenido inicial se utilizará para todas las redes sociales seleccionadas en la parte derecha de esta pantalla.\n' +
          '    Todos los cambios realizados aquí se aplicarán automáticamente a las publicaciones no personalizadas.',
        libelle: 'Título del post *',
        tooltipLibelle: 'Este título no se difundirá en las redes sociales y solo será visible para usted.',
        textContent: 'Contenido de texto del post *',
        textContentInfo: 'Puede redactar libremente su publicación desde el campo a su disposición o aprovechar nuestra\n' +
          '                      herramienta de generación automática de publicaciones\n' +
          '                      gracias a nuestra solución de <b>inteligencia artificial</b>. Para ello, nada más sencillo: haga clic en\n' +
          '                      el botón de abajo y siga las instrucciones.',
        linkToYourVideo: 'Enlace a su vídeo'
      },
      alreadyPublished: 'Este post ya ha sido publicado: <br> eliminación o modificación imposible.',
      customizePost: 'Personalizar el post',
      selectTypePost: 'Seleccionar un tipo de post *',
      chooseTypeOfPost: 'Elegir el tipo de post',
      actionButton: 'Botón de acción',
      typeOfActionButton: 'Elegir el tipo de botón de acción',
      urlActionButton: 'Enlace asociado a su post',
      learnMore: 'Saber más',
      tooltipGoogleUTM: 'Si tiene Google Analytics, puede ingresar aquí el índice de campaña UTM.',
      postWithPictures: 'Publicación con foto(s)',
      typeNews: 'Noticias',
      redactWithAi: 'Redactar su post con IA',
      promoCode: 'Código promocional',
      promoCodeDetail: 'Si desea ofrecer un código promocional utilizable en línea o en el punto de venta.',
      offerLink: 'Enlace de la oferta',
      offerLinkDetail: 'Especifique la URL de la página que permite disfrutar de la oferta en línea.',
      medias: 'Medios',
      IAButtonDisabled: 'Por favor, complete el título antes de utilizar la IA',
      saveDraft: 'Guardar como borrador',
      publish: 'Publicar'
    },
    confirmDelete: {
      title: 'Eliminación de post',
      confirmDeleteSingle: 'Está a punto de eliminar el siguiente post:',
      confirmDeleteMultiple: 'Está a punto de eliminar los siguientes posts:',
      confirmDeleteMultipleBV: 'Está a punto de eliminar los siguientes posts de bienes vendidos:',
      onlyNotDiffused: 'Atención: solo se pueden eliminar los posts no difundidos.',
      notPossible: 'La eliminación no es posible.',
      warningTitle: 'Atención',
      warningPublished: 'Algunos posts ya han sido publicados en las siguientes redes sociales:',
      confirmChoice: '¿Está seguro de que desea continuar?',
      cancel: 'Cancelar',
      confirmDelete: 'Confirmar la eliminación'
    },
    diffusionDisabled: '<p>La gestión de sus posts editoriales en {{ networkName }} no está activada.<br><br>' +
                       'Varias razones pueden explicarlo:</p>' +
                       '<ul style="font-weight: 100">' +
                       '<li>Aún no ha finalizado la transferencia de los derechos necesarios a nuestro equipo de atención al cliente.</li>' +
                       '<li>No está presente en esta red social.</li>' +
                       '<li>No ha activado esta red social en su paquete Ubiflow.</li></ul>' +
                       '<p>¿Sabía que al gestionar toda su estrategia de medios sociales desde su Área de Cliente de Ubiflow optimiza su visibilidad en las redes sociales y ahorra hasta 4 veces más tiempo?</p>',
    iWantToEnableThisNetwork: 'Quiero activar esta red social'
  },
  socialReviews: {
    suggestedReviews: 'Reseñas sugeridas',
    title: 'Reseñas de clientes',
    description: 'Desde esta pestaña, encontrará todas las reseñas de clientes de sus páginas de Google y Facebook.',
    search: {
      openSearch: 'Búsqueda libre',
      media: 'Media',
      rate: 'Calificación',
      creationDate: 'Fecha de creación',
      detectionDate: 'Fecha de detección',
      review: 'Reseña',
      allReview: 'Todas',
      new: 'Nueva',
      toAnswer: 'Por responder',
      answered: 'Respondida',
      deleted: 'Eliminada'
    },
    modal: {
      respondToReview: 'Responder a la reseña',
      respondToIA: 'Responder con IA',
      messageModal: 'Ha respondido a esta reseña'
    },
    table: {
      messageAnswer: 'No ha respondido a esta reseña'
    },
    stats: {
      reviewCount: 'Número de reseñas',
      unansweredReviewsCount: 'Reseñas pendientes de respuesta',
      averageRate: 'Calificación promedio'
    },
    autoAnswers: {
      title: 'Respuestas automáticas a reseñas sin texto',
      subtitle: 'Tiene la posibilidad de redactar respuestas que se enviarán automáticamente a las reseñas que no contienen texto.',
      rate: 'Calificación',
      noAutoAnswer: 'No tiene respuesta automática para esta calificación',
      edit: 'Modificar'
    },
    export: {
      fileNameExportReviews: 'lista_resenas_clientes',
      noticeContent: 'Contenido de la reseña',
      dateOfPublication: 'Fecha de publicación',
      dealerName: 'Nombre del autor',
      pointOfSaleName: 'Punto de venta',
      numberOfStars: 'Número de estrellas'
    },
    titleSuggestedReviews: 'Correo electrónico para solicitar reseñas de clientes',
    text1SuggestedReviews: 'Desde esta página, puede enviar un correo electrónico para solicitar reseñas a sus clientes redactando su propio texto o utilizando el ejemplo ya creado.',
    text2SuggestedReviews: 'Gracias a los enlaces de redirección a sus páginas de Google y Facebook, sus clientes solo tienen que hacer un clic para dejar una reseña.',
    emailIsEmpty: 'El correo electrónico del destinatario está vacío. Por favor complete este campo.',
    sendSelected: 'Enviar la selección',
    enterMail: 'Ingrese el correo electrónico del destinatario'
  },
  contactManager: {
    contactsGenerated: 'Contactos generados',
    allContacts: 'Todos los contactos',
    summaryOfContacts: 'Resumen de contactos',
    contactsByPost: 'Contactos por anuncios',
    contactsByPortal: 'Contactos por portales'
  },
  broadcasts: {
    broadcastLists: 'Lista de difusiones',
    broadcastSocialNetworks: 'Emisiones de redes sociales'
  },
  socialNetworks: {
    dialogPagesSelection: 'Por favor, seleccione la página de Facebook en la que desea distribuir sus publicaciones',
    messageFacebookAutologin: 'Inicie sesión nuevamente con su cuenta profesional para renovar los derechos de publicación de la aplicación',
    titleFacebookPages: 'Páginas autorizadas para publicar',
    facebookDeconnexion: 'Cerrar sesión en Facebook',
    googleDeconnexion: 'Cerrar sesión en Google',
    dialogLocationsSelection: 'Por favor seleccione su negocio de Google donde desea publicar sus publicaciones.',
    dialogOrganizationsSelection: 'Por favor seleccione su organización de Linkedin en la que desea distribuir sus publicaciones',
    newPost: {
      introText: 'Está a punto de crear contenido nuevo para publicar en sus redes sociales. Para ello, primero elija el tipo de publicación entre las que se le ofrecen y siga las instrucciones.',
      createPostLabel: 'Quiere crear una publicación',
      selectPostType: 'Elegir el tipo de publicación',
      fromAd: 'A partir de un anuncio',
      fromSoldProperty: 'A partir de una propiedad vendida',
      editorial: 'Editorial',
      selectRelatedAd: 'Seleccionar el anuncio relacionado',
      title: 'Título',
      reference: 'Referencia',
      price: 'Precio',
      alreadyPosted: 'Este anuncio ya está publicado en una red social',
      cancel: 'Cancelar',
      editPost: 'Editar publicación',
      validateAndContinue: 'Validar y continuar'
    }
  },
  tutoralsVideos: {
    menu: {
      titleMenu: 'Resumen',
      linkDashboard: 'Panel',
      linkAnnouncementsPage: 'Anuncios',
      linkProgramsPage: '  programas',
      linkBroadcast: 'Transmisión',
      linkContactManager: 'Administrador de contactos',
      linkSocialManagement: 'Social Manager'
    },
    subMenu: {
      linkReviews: 'Reseñas de clientes'
    },
    title: 'Vídeos tutoriales',
    infoButtonGoToBack: 'Volver al área de clientes',
    textButtonGuide: 'Exportar guía de usuario',
    label: 'Nuevo video',
    videos: {
      title1: 'Descubre tu panel',
      description1: 'Este primer vídeo te permitirá comprender tu espacio de usuario y descubrir los diferentes elementos integrados en tu panel de control. Descubramos juntos las primeras pestañas para tener una primera comprensión de su entorno.',
      title2: 'Domina la pestaña de anuncios',
      description2: 'Desde nuestra herramienta de entrada, puede crear un anuncio en cualquier momento utilizando el botón "Crear un anuncio" constantemente accesible en su área de clientes. En particular, podrá agregar una descripción personalizada y contenido multimedia.',
      title3: 'La pestaña de transmisión',
      description3: 'Desde la pestaña "Difusión", podrás consultar y modificar tu lista de correo y también recibir un informe de distribución del portal y gestionar la distribución de tus anuncios en un portal.',
      title4: 'Descubrimiento de la pestaña Administrador de contactos',
      description4: 'Descubra la pestaña Administrador de contactos que le permite administrar y centralizar sus contactos y monitorear las interacciones.',
      title5: 'Creando un anuncio',
      description5: 'Descubra cómo crear y publicar con éxito un anuncio desde su espacio de usuario de Ubiflow y simplificar el envío de sus publicaciones publicitarias.',
      title6: 'Respuesta a una reseña de cliente',
      description6: 'Descubra cómo responder a las reseñas de clientes directamente desde el área de clientes de Ubiflow. En este video, le mostramos paso a paso cómo utilizar esta práctica funcionalidad para interactuar con sus clientes y gestionar eficazmente su reputación en línea.'
    }
  },
  statisticsMeta: {
    networksStatistics: 'Estadísticas de sus redes sociales',
    overview: 'Visión general',
    publicationReport: 'Informe de publicaciones',
    discover: 'Visita',
    titleFacebook: 'Estadísticas para tu página de Facebook',
    titleInsta: 'Estadísticas para tu página de Instagram',
    likedPage: 'Menciones j\'aime de la página ',
    viewsNumber: 'Número de vistas',
    followersNumber: 'Número de seguidores',
    likeNumber: 'Número de me gusta',
    numberPublication: 'Número de publicaciones',
    allNumberViews: 'Número total de visualizaciones de medios',
    publication: 'Publicaciones',
    totalInteractions: 'Número total de interacciones con tus publicaciones',
    reach: 'Número total de visualizaciones únicas de medios',
    shares: 'Número de participaciones',
    saves: 'Número de registros de su contenido',
    comments: 'Número de comentarios',
    likes: 'Me gusta de tu contenido',
    accountsEngaged: 'Número de cuentas que han interactuado con tu contenido',
    pageDailyFollows: 'Número de personas que siguen tu página de Facebook',
    pagePostEngagements: 'Número de interacciones con tus publicaciones',
    pageTotalActions: 'Número de clics en los datos de contacto de tu página',
    postsInsta: 'Mensajes de Instagram',
    postsFacebook: 'Publicaciones en Facebook',
    growingYourInstagramCommunity: 'Hacer crecer tu comunidad de Instagram',
    growingYourFacebookCommunity: 'Haz crecer tu comunidad de Facebook',
    boxInfosContentFacebook: 'Debes tener al menos 100 me gusta en tu página de Facebook para tener estadísticas disponibles',
    boxInfosContentInstagram: 'Debes tener al menos 100 seguidores en tu página de Instagram para tener estadísticas disponibles',
    toolTipsStatsContent: 'Estas estadísticas se refieren al rendimiento general de tu página. Los filtros no afectan a estos datos',
    toolTipsStatsGraphContent: 'Utiliza los filtros para resaltar las cifras que quieras ver',
    seePostDetails: 'Ver los detalles del post',
    loadingInProgress: 'Cargando en progreso...',
    nbPeopleWhoSeenPublications: 'Número de personas que han visto tus publicaciones',
    infoNumberStats: 'Los números en la sección "Interacciones" están relacionados con el período indicado en el gráfico de evolución de la comunidad.'
  },
  statisticsLinkedin: {
    titleLinkedin: 'Estadísticas de tu página Linkedin',
    discover: 'Descubre',
    postsLinkedin: 'Publicaciones en Linkedin',
    growingYourLinkedinCommunity: 'Haciendo crecer tu comunidad Linkedin',
    numberImpressionTotal: 'Número de impresiones totales',
    followersNumber: 'Número de seguidores en la página',
    followersNumberByMonth: 'Número de seguidores adicionales por mes',
    numberOfReaction: 'Número de reacciones',
    numberOfComments: 'Número de comentarios',
    numberOfShare: 'Número de compartidos',
    numberCliksOntheLink: 'Número de clics en el enlace'
  },
  autoOpenDialogLinkedin: {
    title: 'Nueva función de Social Manager',
    content: 'Ahora puedes ver las estadísticas de tu cuenta Linkedin directamente desde la sección "Estadísticas" de tu Área de Cliente. ',
    content1: 'Para ello, haga clic en el botón de abajo, y luego en el botón «Linkedin login» en la página de destino.',
    content2: '¡Atención! Para ver las estadísticas de Linkedin desde tu Área de Cliente, debes ser Super Administrador o Administrador de la página de empresa',
    titleCancelledButton: 'Cancelar',
    titleConfirmButton: 'Iniciar sesión',
    disabledMessage: 'Deja de recibir este mensaje'
  },
  statisticsDBKS: {
    numberEditorial: 'Número de post(s) editorial(es)',
    numberAdsPost: 'Número de post(s) publicitario(s)',
    numberDraftPost: 'Número de post(s) en borrador',
    statusOfBroadcasts: 'Estado de compartir tu información en diferentes medios',
    contentOfBroadcasts: 'La solución de presencia local le permite difundir su información en los distintos soportes asociados (Google maps, Apple maps, Waze, etc.).',
    broadcast: 'Emisiones',
    inProgress: 'En curso',
    broadCastError: 'Error de emisión',
    total: 'Total',
    other: 'otro'
  },
  statistics: {
    linkToStatistics: 'Accede a tus estadísticas',
    linkToReportByPosts: 'Accede a tus informes por publicación',
    GrowingYourCommunityOnSocialNetworks: 'Evolución de tu comunidad en las diferentes redes sociales',
    titleAd: 'Título de la publicación',
    publishedAt: 'Publicado el ',
    top: 'TOP'
  },
  autoOpenDialog: {
    title: 'Nueva función de Social Manager',
    content: 'Ahora puedes ver las estadísticas de tus cuentas de Facebook e Instagram directamente desde la sección "Estadísticas" de tu Área de Cliente. ',
    content1: 'Para ello, haz clic en el botón de abajo y, a continuación, en el botón «Iniciar sesión en Facebook» de la página de destino',
    content2: 'Para que tus estadísticas puedan ser reportadas, la red social requiere 100 likes de tu página de Facebook y 100 seguidores de tu cuenta de Instagram. Si no es el caso, ¡no dudes en mantener viva tu comunidad publicando más posts con nuestra solución Social Manager!',
    titleCancelledButton: 'Cancelar',
    titleConfirmButton: 'Acceder',
    disabledMessage: 'No volver a recibir este mensaje'
  },
  autoOpenDialogGoogle: {
    title: 'Nueva Funcionalidad de Social Manager',
    content: 'Ahora puedes consultar las estadísticas de tu cuenta de Google directamente desde la sección "Estadísticas" de tu Espacio de Cliente.',
    content1: 'Para ello, haz clic en el botón de abajo y luego en el botón "Google login" que se encuentra en la página de aterrizaje.',
    content2: '¡Atención! Para visualizar las estadísticas de Google Business Profile desde tu Espacio de Cliente, debes ser Super Administrador o Administrador de la página de empresa.',
    titleCancelledButton: 'Cancelar',
    titleConfirmButton: 'Acceder',
    disabledMessage: 'No recibir más este mensaje'
  },
  KPI: {
    messageErrorLoading: 'Ocurrió un error al cargar'
  },
  etablishmentSheet: {
    messageLoadData: 'Se ha producido un error al cargar los datos',
    messageUploadPhotoError: 'Se ha producido un error al cargar las fotos',
    messageUploadPhotoSuccess: 'Tus fotos se han cargado correctamente y ahora se actualizarán',
    messageDeletedPhotoError: 'Se ha producido un error durante la eliminación',
    messageDeletedPhotoSuccess: 'Tu foto se ha eliminado correctamente',
    errorPhoto2004: 'Los datos introducidos no son válidos',
    errorPhoto2501: 'El PDI tiene demasiadas fotos',
    errorPhoto2502: 'El PDI debe tener al menos una foto',
    errorPhoto2503: 'No se ha podido obtener la foto',
    errorPhoto2504: 'Método de foto no soportado',
    errorPhoto2505: 'La foto es demasiado pequeña',
    errorPhoto2506: 'La foto es demasiado grande',
    errorPhoto2507: 'La foto tiene una proporción incorrecta',
    errorPhoto2508: 'El peso de la foto no es válido',
    errorPhoto2509: 'La foto está duplicada',
    errorPhoto2510: 'La foto no se puede modificar',
    errorPhoto2511: 'Se ha borrado la foto antes de subir una nueva',
    title: 'Datos de su ficha de establecimiento',
    subtitleValidationData: 'Datos de validación',
    subtitleDataGeneral: 'Datos generales',
    subtitleAdress: 'Dirección',
    subtitlePhotos: 'Fotos',
    subtitleVideos: 'Vídeos',
    subtitleHorarios: 'Horarios',
    subtitleHorariosExcepcionales: 'Horarios Excepcionales',
    subtitleWebsites: 'Sitios web',
    idExternal: 'Id externo',
    companyName: 'Nombre de la empresa',
    tradeName: 'Nombre comercial',
    longTradeName: 'Nombre comercial largo',
    contactName: 'Nombre de contacto',
    firstNameOfContact: 'Nombre del contacto',
    phone: 'Teléfono',
    phone2: 'Teléfono 2',
    phone3: 'Teléfono 3',
    mobile: 'Móvil',
    mail: 'Correo electrónico profesional',
    mailAdmin: 'Correo electrónico administrativo',
    statusCompany: 'Estado de la empresa',
    placeholderStatusCompany: 'Por favor, seleccione el estado',
    underConstruction: 'En construcción (nunca abierto)',
    temporarilyClosed: 'Cerrado temporalmente',
    siret: 'Siret',
    openingDate: 'Fecha d\'ouverture',
    mediaStoreGoogle: 'Códigos de tienda Medias (Google)',
    validationMobile: 'Validación : Número de móvil',
    validationMail: 'Validación : Dirección de correo electrónico',
    businessAddress: 'Dirección comercial',
    businessAddressComplement: 'Complemento de la dirección comercial',
    postalCodeCompany: 'Código postal de la empresa',
    cityCompany: 'Ciudad de la empresa',
    country: 'País de la empresa',
    latitude: 'Latitud',
    longitude: 'Longitud',
    geoTitleButton: 'Geolocalizar dirección en el mapa',
    addCatchmentArea: 'Añadir una zona de captación',
    infoCatchmentAreaContent1: 'Recomendamos utilizar áreas de captación por PlaceId para mejorar su precisión',
    infoCatchmentAreaContent2: 'Puedes utilizar el ',
    infoCatchmentAreaContent2Suite: 'proporcionado por Google',
    infoCatchmentAreaContent3: 'El resultado se mostrará en forma de tooltip. La primera línea en negrita corresponde al nombre y la segunda al PlaceId',
    days: 'Días',
    date: 'Fechas',
    status: 'Status',
    fullHours: '24/24',
    duplicate: 'Duplicado',
    delete: 'Borrar',
    addSchedule: 'Añadir un periodo',
    actions: 'Acciones',
    open: 'Abierto',
    close: 'Cerrado',
    save: 'Guardar el formulario',
    savePictures: 'Guardar fotos',
    cancel: 'Cancelar',
    create: 'Crear',
    logo: 'Logotipo',
    profile: 'Perfil',
    cover: 'Portada',
    gallery: 'Galería',
    minSize: '450x450px mínimo',
    maxSize: '5200x5200px máximo',
    weightBetween: 'Entre 10Kb y 4Mb',
    maxPhotosGallery: 'Máximo 20 fotos',
    chooseFile: 'Elige un archivo',
    chooseAdday: 'Añadir un día',
    chooseSeveralDays: 'Añadir varios días',
    tooltipContentIdExterne: 'Introduzca el número y/o letra identificador que será único para este establecimiento',
    tooltipContentCompanyName: 'Nombre de la empresa del punto de interés',
    tooltipContentNomCommerce: 'Nombre del punto de interés',
    tooltipContentLongName: 'Nombre largo, utilizado prioritariamente en ciertos medios que lo permiten (Google...)',
    tooltipContentContactName: 'Nombre de contacto del punto de interés',
    tooltipContentContactFirstname: 'Nombre de contacto del punto de interés',
    tooltipContentPhone: 'Número de teléfono principal del punto de interés',
    tooltipContentPhone2: 'Teléfono n°2 del punto de interés',
    tooltipContentPhone3: 'Teléfono n°3 del punto de interés',
    tooltipContentMobile: 'Teléfono móvil del punto de interés',
    tooltipContentMail: 'Dirección de correo electrónico pública enviada a los portales para su publicación como «contacto»',
    tooltipContentMailAdmin: 'Dirección de correo electrónico privada, utilizada para la gestión del servicio y la administración de registros, en particular en Google My Business',
    tooltipContentStatus: 'Estado del punto de interés',
    tooltipContentSIRET: 'Número SIRET del punto de interés',
    tooltipContentOpeningDate: 'Fecha de la primera apertura de su punto de venta. Debe ser en el pasado o como máximo 1 año en el futuro',
    tooltipContentStoreCodeMedias: 'Códigos de tienda en los medios',
    tooltipContentValidationDataMobile: 'Número de teléfono móvil utilizado para validar el registro de GBP',
    tooltipContentValidationDataMail: 'Dirección de correo electrónico utilizada para validar el registro en GBP',
    tooltipContentAdresseCommerce: 'Dirección del punto de interés (línea 1)',
    tooltipContentAdresseCommerce2: 'Dirección del punto de interés (línea 2)',
    tooltipContentLatitude: 'Latitud del punto de interés (posición en la calle o en el centro comercial)',
    tooltipContentLongitude: 'Longitud del punto de interés (posición en la calle o en el centro comercial)',
    saveConfirmation: '¿Realmente desea guardar el formulario?',
    saveConfirmationPictures: '¿Realmente quieres guardar las fotos?',
    errorSave: 'La información no se ha podido guardar debido a una cancelación o a un error',
    errorSavePictures: 'Las fotos no se han podido guardar debido a una cancelación o a un error',
    successSave: 'Los cambios se han guardado correctamente',
    cancelConfirmation: '¿Realmente quieres cancelar el guardado?',
    addVideo: 'Añadir un vídeo',
    contentVideo: 'Puede añadir varios enlaces a vídeos. Se analizarán y, a continuación, se difundirán en los medios de comunicación correspondientes, siempre que cumplan las siguientes restricciones:',
    conditionVideo: 'La url debe ser un acceso directo al archivo',
    exampleVideo: 'ejemplo: https://exampleVideo/2ssezdsez2dd15e.mp4',
    addUrlVideo: 'Añade la url del vídeo',
    minWeightVideo: 'Peso: 75 Mio máximo',
    timeMaxVideo: 'Duración: 30 segundos máximo',
    resolutionVideo: 'Resolución: 720p mínimo',
    warningDiffusion: '¡Atención! Todas las difusiones son definitivas y su enlace no puede eliminarse'
  },
  statisticsGoogle: {
    overview: 'Visión general',
    titleGoogle: 'Estadísticas generales de Google',
    sheetEtablishmentEngagement: 'Compromiso en la ficha del establecimiento',
    actions: 'Acciones realizadas desde la ficha de establecimiento',
    titleGoogleGraph: 'Evolución del número de búsquedas en Google',
    messages: 'Mensajes',
    searchByDesktop: 'Búsqueda en Google por ordenador',
    searchGoogleMapsByDesktop: 'Búsqueda de Google Maps por ordenador',
    searchByMobile: 'Búsqueda de Google por móvil',
    searchGoogleMapsByMobile: 'Búsqueda de Google Maps por móvil',
    numberSearchByDay: 'Número de búsquedas por día',
    numberConversationByDay: 'Número de conversaciones por mensaje recibidas en el sitio',
    numberCallItinerary: 'Número de solicitudes de itinerario',
    numberClickedButtonCall: 'Número de clics en el botón de llamad',
    numberClickedWebSite: 'Número de clics en el sitio we',
    infoNumberStats: 'Los números en la sección "En la ficha del establecimiento" están relacionados con el período indicado en el gráfico de evolución de la comunidad.'
  },
  SOH: {
    chooseDate: 'Elija una fecha',
    textLinked: 'Estado de salud de la batería proporcionado por una entidad certificada como',
    warnings: {
      lowScore: 'Atención: una puntuación SOH inferior al 70% indica una batería en mal estado.'
    },
    validation: {
      soh: {
        scoreInvalid: 'La puntuación SOH debe ser un número válido.',
        scoreRange: 'La puntuación SOH debe estar entre 0 y 100%.',
        dateRequired: 'La fecha de la prueba SOH es obligatoria.',
        dateFormat: 'El formato de fecha debe ser DD/MM/AAAA.',
        dateFuture: 'La fecha de la prueba no puede estar en el futuro.',
        kilometrageInvalid: 'El kilometraje debe ser un número válido.',
        kilometrageNegative: 'El kilometraje no puede ser negativo.',
        capaciteInvalid: 'La capacidad debe ser un número válido.',
        capacitePositive: 'La capacidad debe ser mayor que 0.',
        autonomieInvalid: 'La autonomía debe ser un número válido.',
        autonomiePositive: 'La autonomía debe ser mayor que 0.',
        expirationPast: 'La fecha de expiración debe estar en el futuro.',
        urlInvalid: 'La URL no es válida'
      }
    }
  }
}
